<template>
  <div @click.stop>
    <transition name="modal" v-if="visivel">
      <div class="w3-modal" style="display: block;">
        <div class="w3-modal-content" @click.stop  id="modalEntregaNoAto">
          
          <header class="w3-container">
            <span @click="cancelarBuscarEntregasNoAto()" class="w3-button w3-display-topright">&times;</span>
            <h3 class="texto-vermelho titulo">Entregas no Ato</h3>
          </header>

          <exibir-processando v-if="processando"/>
          
          <div class="w3-col l12 m12 s12 w3-padding-row"  style="padding:0">
        
            <div v-if="tipo_entrega !== 'ATO' && tipo_entrega !== 'RLR'" class="w3-col s6 l3 " style="text-align:right; margin-top:5px;border: 2px solid transparent!important;">
              <button class="w3-col w3-button w3-green"
                style="padding:0px; border:3px transparent; height:30px;"
                v-on:click="marcarTodosAgendar()">
                <i class="fa fa-shipping-fast"></i> 
                Agendar - todos
              </button>
            </div>
                    
            <div v-if="tipo_entrega !== 'ATO'" class="w3-col s6 l3" style="text-align:right; margin-top:5px;border: 2px solid transparent!important;">
              <button class="w3-col w3-button w3-blue" 
                style="color:white!important; padding:0px; height:30px;" 
                :disabled="recebimento_na_entrega"
                v-on:click="marcarTodosEntregarAgora()">
                <i class="fa fa-user-clock"></i>
                No ato - todos 
              </button>
                
            </div>
                    
            <div v-if="tipo_entrega !== 'ATO'" class="w3-col s6 l3 " style="text-align:right; margin-top:5px; border: 2px solid transparent!important; ">
              <button class="w3-col w3-button w3-orange w3-text-white" 
                style="padding:0px; height:30px;" 
                v-on:click="verificarAbrirModalTipoRetirarLojasRede">
                <i class="fa fa-store"></i> 
                Retirar rede - todos
              </button>
            </div>
            
            <div v-if="tipo_entrega !== 'ATO' && tipo_entrega !== 'RLR' && tipo_entrega !== 'EPG'"  class="w3-col s6 l3 " style="text-align:right; margin-top:5px; border: 2px solid transparent!important; ">
              <button class="w3-col w3-button w3-theme" 
                style="padding:0px; height:30px;" 
                v-on:click="marcarTodosSemPrevisao()">
                <i class="fa fa-hourglass-half"></i> 
                Sem agend. - Todos
              </button>
            </div>
          </div>
          
          <div class="w3-container" style="padding:0px!important;">
            <div class="w3-responsive">
              
              <div v-for="produto in produtos_entrega_no_ato" :key="produto.produto_id" :class="{'active' : produto.card_ativo}" class="w3-hide-large card-ato w3-border" style="margin-top: 5px;">
              
                <div>
                  <label v-if="produto.quantidade_entregar_agora > produto.quantidade && tipo_entrega !== 'RLR'">
                    <i class="fa fa-circle w3-text-theme"></i>
                  </label>   
                  <label v-if="false"><i class="fa fa-circle w3-text-orange"></i></label>      
                </div>
                
                <div>
                  <legenda v-show="produto.quantidade_agendar > 0 && produto.quantidade_entrega_ato > 0  && produto.tipo_retirar_lojas_rede === 'N'">
                    <div>Entrega ato parcial </div>
                      <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-blue"></i>
                      <i class="fas fa-circle w3-text-green"></i>
                    </strong>
                  </legenda>
                  
                  <legenda v-show="produto.quantidade_agendar > 0 && produto.quantidade_entrega_ato > 0  && produto.tipo_retirar_lojas_rede !== 'N'">
                    <div>Entrega ato parcial</div>
                      <strong slot="referencia" class="max-width">
                      <i class="fas fa-circle w3-text-blue"></i>
                      <i class="fas fa-circle w3-text-orange"></i>
                    </strong>
                  </legenda>
                  
                  <legenda 
                    v-show="produto.quantidade_agendar == 0 &&
                    produto.quantidade_entrega_ato > 0 ||  
                    produto.quantidade_entrega_ato_dep > 0 || 
                    produto.quantidade_entrega_ato_exp > 0">
                    <div>Entrega ato total</div>
                    <strong slot="referencia" class="max-width"><i class="fas fa-circle w3-text-blue"></i></strong>
                  </legenda>
                  
                  <legenda v-show="produto.quantidade_agendar > 0 && produto.quantidade_entrega_ato == 0 && produto.tipo_retirar_lojas_rede === 'N' && tipo_entrega !== 'RLR'">
                    <div>Entregar</div>
                    <strong slot="referencia" class="max-width"><i class="fas fa-circle w3-text-green"></i></strong>
                  </legenda>
                  
                  <legenda v-show="produto.tipo_retirar_lojas_rede !== 'N' && produto.quantidade_agendar > 0 && produto.quantidade_entrega_ato == 0">
                    <div>Retirar Loja rede</div>
                    <strong slot="referencia" class="max-width"><i class="fas fa-circle w3-text-orange"></i></strong>
                  </legenda>
                  
                  <legenda v-show="produto.quantidade_sem_agendamento > 0">
                    <div>Sem agendamento</div>
                    <strong slot="referencia" class="max-width"><i class="fas fa-circle w3-text-theme"></i></strong>
                  </legenda>

                  <strong>{{formatarValor(produto.produto_id, 0)}}</strong>
                  <strong style="text-decoration: underline;" @click="ativarCard(produto)" class="max-width">{{ produto.nome }}</strong>
                  
                  <div>
                    <span class="max-width">{{ produto.marca }}</span>
                  </div>
                  
                  <div 
                    v-if="
                    (
                      (
                        (produto.definir_lote === 'Sim') || 
                        (produto.tipo_controle_estoque === 'P') ||  
                        (produto.tipo_controle_estoque === 'T') ||  
                        (produto.tipo_controle_estoque === 'G') || 
                        (produto.tipo_controle_estoque === 'L')      
                      ) &&
                      (!produto.card_ativo)
                    )">
                      <span v-if="!validarDefinicaoLoteProduto(produto.produto_id, produto.quantidade)" class="max-width">
                      Definido lote: 
                      <strong class="w3-text-red">Definição pendente</strong>
                    </span>
                    <span v-else class="max-width">
                      Definido lote: 
                      <strong class="w3-text-green">Sim</strong>
                    </span>
                  </div>
                  
                  <div v-show="!colunas_itens_ocultar.includes('cQuantidade_Pedida') && !produto.card_ativo ">
                    Qtd. pedida: <strong class="max-width">{{ formatarValor(produto.quantidade_pedida) }}</strong>
                  </div>
                  
                  <div v-show="!produto.card_ativo">
                    Retirar ato:  <strong class="max-width">{{ formatarValor(produto.quantidade_entrega_ato) }}</strong>
                  </div>
                  
                  <div v-show="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Dep') && !produto.card_ativo">
                    Retirar ato dep.: <strong class="max-width">{{ formatarValor(produto.quantidade_entrega_ato_dep) }}</strong>
                  </div>
                  
                  <div v-show="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Exp') && !produto.card_ativo">
                    Retirar ato exp.: <strong class="max-width">{{ formatarValor(produto.quantidade_entrega_ato_exp) }}</strong>
                  </div>
                  
                  <div v-show="!colunas_itens_ocultar.includes('cQuantidade_Agendar') && !produto.card_ativo">
                    Agendar: <strong class="max-width">{{ formatarValor( produto.quantidade_agendar) }}</strong>
                  </div>
                  
                  <div 
                    class="w3-center sem-agendamento" 
                    v-show="!colunas_itens_ocultar.includes('cQuantidade_Sem_Agendamento') && 
                    !produto.card_ativo && produto.quantidade_sem_agendamento > 0">
                    <strong>Sem Agendamento: {{formatarValor(produto.quantidade_sem_agendamento, 3)}}</strong> 
                  </div>
                  
                  <div v-show="produto.card_ativo" >
                    <span class="w3-col">Qtd. disponível loja: <strong>{{ formatarValor(produto.estoque_loja) }}</strong></span>
                    <span >Qtd. disponível rede: <strong>{{ formatarValor(produto.estoque_rede) }}</strong></span>
                    <span>{{ produto.unidade }}</span> 
                  </div>
                </div>
                
                <div v-show="produto.card_ativo" class="w3-container w3-animate-zoom">
                  <div class="w3-container w3-border w3-padding-small" style="border-radius:10px; background-color:#ebebeb; box-shadow: #ddd 1px 2px 3px 4px;">
                    <div class="w3-col" v-if="!colunas_itens_ocultar.includes('cQuantidade_Pedida')" >
                      <div class="w3-half" style="display: inline-block">
                        <div class="w3-col m3 s3">
                          <span style="text-decoration: underline;">Pedida:</span>
                        </div>
                        
                        <div class="w3-col m9 s9  w3-center">
                          <div class="w3-border" style="width: 130px;display: inline-block;">
                            <vue-numeric 
                              :precision="3" 
                              separator="." 
                              :disabled="(recebimento_na_entrega && tipo_entrega == 'ESA') || (tipo_entrega == 'ATO')" 
                              class=" w3-center"
                              style="border:none; width: 70px; background-color:#ebebeb;" 
                              v-model="produto.quantidade_pedida"
                            />
                          </div>
                          <span>{{ produto.unidade }}</span> 
                        </div>
                        
                      </div>
                    </div>
                  
                    <div class="w3-col " >
                      <div class="w3-half" style="display: inline-block">
                      
                        <div class="w3-col m3 s3 ">
                          <span 
                            style="text-decoration: underline;" 
                            class="w3-text-blue" 
                            @click="ativarDesativarProdutoSelecionado(produto , 'Retirar ato')">
                            <strong>Retirar ato:</strong>
                          </span>
                        </div>
                        
                        <div class="w3-col m9 s9  w3-center">
                          <div class="w3-border w3-white " style="width: 130px;display: inline-block;">
                            <span
                              class="w3-left"
                              v-if="tipo_entrega != 'ATO' || 
                              parametros_empresa.tipo_selec_local_entrega_ato == 'S'" 
                              @click="diminuirValor(produto)"
                              style="height: 42px; margin-right: 0px; padding-top:12px;">
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>

                            <strong>
                              <vue-numeric 
                                :precision="3" 
                                separator="." 
                                class=" w3-center w3-white" 
                                onClick="this.select()"
                                style="border:none; width: 70px; background-color:#ebebeb;" 
                                v-on:keyup.native="arrumarGrid(produto, true)" 
                                v-model="produto.quantidade_entrega_ato"
                              />
                            </strong>

                            <span
                              class="w3-right"
                              v-if="tipo_entrega != 'ATO' || 
                              parametros_empresa.tipo_selec_local_entrega_ato == 'S'" 
                              @click="aumentarValor(produto)"
                              style="height: 42px; margin-left: 0px; padding-top:12px;">
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                          </div>
                          <span>{{ produto.unidade }}</span> 
                        </div>
                      </div>
                    </div>
                
                    <div class="w3-col" v-if="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Dep')" >
                      <div class="w3-half" style="display: inline-block">
                        <div
                          @click="ativarDesativarProdutoSelecionado(produto, 'Entrega dep')"
                          style="text-decoration: underline;"
                          class="w3-col s3 m3 w3-text-blue">
                          <strong >Retira dep:</strong>
                        </div>
                        
                        <div class="w3-col s9 m9  w3-center">
                          <div class="w3-border w3-white" style="width: 130px;display: inline-block;">
                            <span 
                              class="w3-left"
                              @click="diminuirValorDep(produto)"
                              style="height: 42px; margin-right: 0px; padding-top: 12px; padding-bottom: 12px;">
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>

                            <strong>
                              <vue-numeric
                                :precision="3" 
                                separator="." 
                                onClick="this.select()"
                                class=" w3-center w3-white" 
                                style="border:none; width: 70px; background-color:#ebebeb; " 
                                v-on:keyup.native="arrumarGrid(produto, true)" 
                                v-model="produto.quantidade_entrega_ato_dep"
                              />
                            </strong>
                            <span
                              class="w3-right"
                              @click="aumentarValorDep(produto)"
                              style="height: 42px; margin-right: 0px; padding-top: 12px">
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                          </div>
                          <span>{{ produto.unidade }}</span> 
                        </div>
                      </div>
                    </div>
                  
                    <div  class="w3-col" v-if="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Exp')" >
                      <div class="w3-half" style="display: inline-block">
                        <div class="w3-col s3 m3">
                          <span 
                            class="w3-text-blue"
                            @click="ativarDesativarProdutoSelecionado(produto, 'Entrega exp')"
                            style="text-decoration: underline;">
                            <strong>Retira exp:</strong>
                          </span>
                        </div>
                        
                        <div class="w3-col s9 m9  w3-center" >
                          <div class="w3-border w3-white w3-center" style="width: 130px;display: inline-block;">
                            <span 
                              class="w3-left"
                              @click="diminuirValorExp(produto)"
                              style="height: 42px; margin-right: 0px; padding-top:12px; padding-bottom:12px;">
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>
                          
                            <strong>
                              <vue-numeric 
                                :precision="3" 
                                separator="." 
                                class="w3-white w3-center" 
                                style="border:none; width: 70px; background-color:#ebebeb;" 
                                v-on:keyup.native="arrumarGrid(produto, true)" 
                                v-model="produto.quantidade_entrega_ato_exp"
                              />
                            </strong>
                          
                            <span  
                              class="w3-right"
                              @click="aumentarValorExp(produto)"
                              style="height: 42px; margin-right: 0px; padding-top:12px;">
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                          </div>
                          <span>{{ produto.unidade }}</span> 
                        </div>
                      </div>
                    </div>
                  
                    <div class="w3-col" v-if="!colunas_itens_ocultar.includes('cQuantidade_Agendar')">
                      <div class="w3-half" 
                        style="display: inline-block" 
                        v-if="tipo_entrega != 'ATO'|| parametros_empresa.tipo_selec_local_entrega_ato == 'S'">
                        <div class="w3-col m3 s3">
                          <span 
                            v-if="tipo_entrega !== 'RLR' &&
                            produto.tipo_retirar_lojas_rede === 'N'" 
                            class="w3-text-green" 
                            @click="ativarDesativarProdutoSelecionado(produto, 'agendar')">
                            <strong style="text-decoration: underline; padding-right:1.5vw;">Agendar:</strong>
                          </span>
                          
                          <span 
                            v-if="tipo_entrega === 'RLR' || 
                            produto.tipo_retirar_lojas_rede !== 'N' "
                            class="w3-text-orange" 
                            @click="ativarDesativarProdutoSelecionado(produto , 'rede')">
                            
                            <strong  
                              v-if="produto.tipo_retirar_lojas_rede === 'N'" 
                              style="text-decoration: underline;">
                              Não retirar loja rede:
                            </strong>
                            
                            <strong  
                              v-if="produto.tipo_retirar_lojas_rede === 'S'" 
                              style="text-decoration: underline;">
                              Retirar loja rede 
                              <strong class="w3-text-green">Posteriomente</strong>:
                            </strong>
                            
                            <strong  
                              v-if="produto.tipo_retirar_lojas_rede === 'I'" 
                              style="text-decoration: underline;">
                              Retirar loja rede 
                              <strong class="w3-text-green">Imediatamente</strong>:
                            </strong>
                            
                            <strong  
                              v-if="produto.tipo_retirar_lojas_rede === 'T'" 
                              style="text-decoration: underline;">
                              Retirar loja rede 
                              <strong class="w3-text-green">Posteriormente (Transferir)</strong>:
                            </strong>
                          </span>
                        </div>
                        
                        <div class="w3-col m9 s9 w3-center">
                          <div class="w3-border w3-white" style="width: 130px;display: inline-block;">
                            <span 
                              class="w3-left"
                              v-if="tipo_entrega == 'ESA' "  
                              @click="diminuirValorAgendar(produto)"
                              style="height: 42px; margin-right: 0px; padding-top:12px; padding-bottom:12px;">
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>
                            <strong>
                              <vue-numeric 
                                :precision="3" 
                                separator="." 
                                onClick="this.select()"
                                class="w3-white w3-center" 
                                v-if="tipo_entrega != 'ATO' || parametros_empresa.tipo_selec_local_entrega_ato == 'S'" 
                                style="border:none; width: 70px; background-color:#ebebeb; "
                                v-on:keyup.native="arrumarGrid(produto, true)" 
                                :disabled="tipo_entrega === 'ESA' && parametros_empresa.tipo_selec_local_entrega_ato !== 'S'" 
                                v-model="produto.quantidade_agendar"
                              />
                            </strong>
                            <span 
                              class="w3-right"
                              v-if="tipo_entrega == 'ESA'"  
                              @click="aumentarValorAgendar(produto)"
                              style="height: 42px; margin-right: 0px; padding-top:12px;">
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                          </div>
                          <span>{{produto.unidade}}</span> 
                        </div>
                        
                        <div v-if="!colunas_itens_ocultar.includes('cQuantidade_Sem_Agendamento')">
                          <strong v-if="valor_invalido " class="w3-text-theme">Quantidade inválida!</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="w3-center sem-agendamento" v-if="!colunas_itens_ocultar.includes('cQuantidade_Sem_Agendamento')">
                    <strong>Sem Agendamento: {{formatarValor(produto.quantidade_sem_agendamento, 3)}}</strong> 
                  </div>
                
                  <div class="w3-center" v-if="!colunas_itens_ocultar.includes('cData_Prevista_Entrega')">
                    <input type="date" 
                      class="input-entra-ato w3-border" 
                      style="font-size: 14px;" 
                      v-model="produto.data_prevista" 
                      :class="{ 'hide-data-previsao'
                      :produto.quantidade_sem_agendamento != produto.quantidade }"
                    />
                  </div>
                  
                  <div class="w3-margin-top">
                    <span v-if="produto.tipo_controle_estoque == 'N'"></span>
                      <span 
                        v-else-if="(produto.tipo_controle_estoque == 'L' ||
                        produto.tipo_controle_estoque == 'P' ||
                        produto.tipo_controle_estoque == 'T' ||
                        produto.tipo_controle_estoque == 'G') &&
                        validarDefinicaoLoteProduto(produto.produto_id, produto.quantidade)"
                        class="w3-text-indigo">
                        <span v-for="(lote, key) in lotesDefinidosProduto(produto.produto_id)">
                        <span v-if="key > 0">, </span>Lote: {{lote}}
                      </span>
                    </span>

                    <span 
                      v-else-if="(produto.tipo_controle_estoque == 'L' ||
                      produto.tipo_controle_estoque == 'P' ||
                      produto.tipo_controle_estoque == 'T' ||
                      produto.tipo_controle_estoque == 'G') &&
                      !validarDefinicaoLoteProduto(produto.produto_id, produto.quantidade) &&
                      (tipo_entrega == 'ATO' ||
                      tipo_entrega == 'EPG' ||
                      tipo_entrega == 'RLR')" 
                      class="w3-text-orange">
                      Definição pendente
                    </span>
                    
                    <span 
                      v-else-if="(produto.tipo_controle_estoque == 'L' ||
                      produto.tipo_controle_estoque == 'P' ||
                      produto.tipo_controle_estoque == 'T' ||
                      produto.tipo_controle_estoque == 'G') &&
                      tipo_entrega == 'ESA'">
                      Não permitido
                    </span>
                  </div>

                  <div class="w3-col" v-show="(produto.tipo_controle_estoque != 'N') || (tipo_entrega!=='ATO')">

                    <div class="w3-margin-bottom w3-margin-top w3-col s6 m6 l6" v-if="produto.tipo_controle_estoque != 'N'">
                      <center>
                        <button 
                          class="w3-button w3-theme w3-border w3-mobile" 
                          style="font-size: 15px; padding-left: 10px;"
                          @click="definirLoteEntregaAto(produto)">
                          <i style="font-size: 2vh;" class="fas fa-dolly"></i>&nbsp;Definir lote
                        </button>
                      </center>
                    </div>

                    <div class="w3-margin-bottom w3-margin-top w3-col s6 m6 l6">
                      <button 
                        v-show="tipo_entrega!=='ATO'"
                        style="font-size: 15px; padding-left: 10px;" 
                        @click="definirTipoRetirarLojasRede(produto)"
                        class="w3-button w3-orange w3-text-white w3-border w3-mobile">
                        <i style="font-size: 2vh;" class="fas fa-cart-arrow-down"></i>&nbsp;
                        Retirar loja rede 
                      </button>
                    </div>
                  </div>
                
                  <div class="w3-center w3-margin-bottom" v-show="!colunas_itens_ocultar.includes('cTipo_Local_Padrao_Entrega_Ato')">
                    <span style="color: #2980b9; font-weight: bold;" v-show="produto.tipo_local_padrao_entrega_ato == 'L'">Loja</span>
                    <span style="color: #27ae60; font-weight: bold;" v-show="produto.tipo_local_padrao_entrega_ato != 'L'">Depósito</span>
                  </div>
                </div>
              </div>
      
              <!-- tabela desktop-->
              <table class="w3-table-all w3-striped w3-border table-entrega-ato w3-hide-small w3-hide-medium" style="white-space: nowrap;" id="tabelaEntregaAto">
                <thead class="w3-light-grey">
                  <th></th>
                  <th></th>
                  <th>Produto</th>
                  <th>Nome</th>
                  <th>Marca</th>
                  <th>Estoque ent ato</th>
                  <th>Est. Rede (disponivel)</th>
                  <th>Est. rede (Transf. pend.)</th>
                  <th class="w3-center">Und</th>
                  <th v-if="!colunas_itens_ocultar.includes('cQuantidade_Pedida')">Qtd. pedida</th>
                  <th>Qtd. ent. agora</th>
                  <th v-if="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Dep')">Ent. ato dep</th>
                  <th v-if="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Exp')">Ent. ato exp</th>
                  <th v-if="!colunas_itens_ocultar.includes('cQuantidade_Agendar')">Qtd. agendar</th>
                  <th v-if="!colunas_itens_ocultar.includes('cQuantidade_Sem_Agendamento')">Sem agendamento</th>
                  <th v-if="!colunas_itens_ocultar.includes('cData_Prevista_Entrega')">Data prevista</th>
                  <th class="w3-center">Definição lote</th>
                  <th>Opções de lote</th>
                  <th>Retirar lojas rede</th>
                  <th v-if="!colunas_itens_ocultar.includes('cNome_Empresa_Ret_Lojas_Rede')">Empresa retirar lojas rede</th>
                  <th class="w3-center" v-if="!colunas_itens_ocultar.includes('cTipo_Local_Padrao_Entrega_Ato')">Tipo local padrão</th>
                  <!-- <th>Lotes</th> -->
                
                </thead>
                <tbody>
                  <tr v-for="produto in produtos_entrega_no_ato" class="label-clicavel">
                    <td>
                      <label v-if="produto.quantidade_entregar_agora > produto.quantidade" >
                        <i class="fa fa-circle w3-text-theme"></i>
                      </label>   
                      <label v-if="false"><i class="fa fa-circle w3-text-orange"></i></label>      
                    </td>
                    <td>
                      <input class="w3-check" type="checkbox" v-model="produto.selecionado">
                    </td>
                    <td class="max-width">{{formatarValor(produto.produto_id, 0)}}</td>
                    <td class="max-width">{{ produto.nome }}</td>
                    <td class="max-width">{{ produto.marca }}</td>
                    <td class="max-width">{{ formatarValor(produto.estoque_loja) }}</td>
                    <td class="max-width">{{ formatarValor(produto.estoque_rede) }}</td>
                    <td class="max-width">{{ formatarValor(produto.transf_pendentes_rede) }}</td>
                    <td class="max-width">{{ produto.unidade }}</td>
                    
                    <td class="w3-center padding-0 max-width" v-if="!colunas_itens_ocultar.includes('cQuantidade_Pedida')">
                      <vue-numeric 
                        :precision="3" 
                        separator="." 
                        class="input-entra-ato" 
                        v-on:keyup.native="arrumarGrid(produto, true)" 
                        v-model="produto.quantidade_pedida"
                      />
                    </td>

                    <td class="w3-center padding-0 max-width">
                      <vue-numeric 
                        :precision="3" 
                        separator="." 
                        class="input-entra-ato" 
                        :disabled="(recebimento_na_entrega && tipo_entrega == 'ESA') || 
                        (tipo_entrega == 'ATO')" 
                        v-on:keyup.native="arrumarGrid(produto, true)" 
                        v-model="produto.quantidade_entrega_ato"
                      />
                    </td>

                    <td class="w3-center padding-0 max-width" v-if="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Dep')">
                      <vue-numeric 
                        :precision="3" 
                        separator="." 
                        class="input-entra-ato" 
                        v-on:keyup.native="arrumarGrid(produto, true)" 
                        v-model="produto.quantidade_entrega_ato_dep"
                      />
                    </td>
                    
                    <td class="w3-center padding-0 max-width" v-if="!colunas_itens_ocultar.includes('cQuantidade_Entrega_Ato_Exp')">
                      <vue-numeric 
                        :precision="3" 
                        separator="." 
                        class="input-entra-ato" 
                        v-on:keyup.native="arrumarGrid(produto, true)" 
                        v-model="produto.quantidade_entrega_ato_exp"
                      />
                    </td>
                    
                    <td class="w3-center padding-0 max-width" v-if="!colunas_itens_ocultar.includes('cQuantidade_Agendar')">
                      <vue-numeric 
                        :precision="3" 
                        separator="." 
                        class="input-entra-ato" 
                        v-on:keyup.native="arrumarGrid(produto, true)" 
                        :disabled="tipo_entrega != 'ESA'" 
                        v-model="produto.quantidade_agendar"
                      />
                    </td>

                    <td class="w3-center sem-agendamento max-width" v-if="!colunas_itens_ocultar.includes('cQuantidade_Sem_Agendamento')">
                      {{formatarValor(produto.quantidade_sem_agendamento, 3)}}
                    </td>

                    <td class="w3-center padding-0 max-width" v-if="!colunas_itens_ocultar.includes('cData_Prevista_Entrega')">
                      <input 
                        type="date" 
                        class="input-entra-ato" 
                        style="font-size: 14px;" 
                        v-model="produto.data_prevista" 
                        :class="{ 'hide-data-previsao': produto.quantidade_sem_agendamento != produto.quantidade }"
                      />
                    </td>

                    <td class="max-width w3-center">
                      <span 
                        v-if="produto.tipo_controle_estoque == 'N'">
                        -----
                      </span>
                      
                      <span 
                        v-else-if="(produto.tipo_controle_estoque == 'L' ||
                        produto.tipo_controle_estoque == 'P' ||
                        produto.tipo_controle_estoque == 'T' ||
                        produto.tipo_controle_estoque == 'G') &&
                        validarDefinicaoLoteProduto(produto.produto_id, produto.quantidade)"
                        class="w3-text-indigo">
                        <span v-for="(lote, key) in lotesDefinidosProduto(produto.produto_id)">
                          <span v-if="key > 0">,</span>
                          {{lote}}
                        </span>
                      </span>
                      
                      <span 
                        v-else-if="(produto.tipo_controle_estoque == 'L' ||
                        produto.tipo_controle_estoque == 'P' ||
                        produto.tipo_controle_estoque == 'T' ||
                        produto.tipo_controle_estoque == 'G') &&
                        !validarDefinicaoLoteProduto(produto.produto_id, produto.quantidade) &&
                        (tipo_entrega == 'ATO' || tipo_entrega == 'EPG' || 
                        tipo_entrega == 'RLR')" class="w3-text-orange">
                        Definição pendente
                      </span>
                      
                      <span 
                        v-else-if="(produto.tipo_controle_estoque == 'L' ||
                        produto.tipo_controle_estoque == 'P' ||
                        produto.tipo_controle_estoque == 'T' ||
                        produto.tipo_controle_estoque == 'G') &&
                        tipo_entrega == 'ESA'">
                        Não permitido
                      </span>
                    </td>
                    
                    <td >
                      <button 
                        v-if="produto.tipo_controle_estoque != 'N'"
                        class="w3-button w3-text-theme w3-border w3-mobile" 
                        @click="definirLoteEntregaAto(produto)">
                        Definir lote
                      </button>
                      <span 
                        v-if="produto.tipo_controle_estoque == 'N'">
                        -----
                      </span>
                    </td>
                    
                    <td class="max-width">
                      <select
                        class="w3-input w3-border w3-block" 
                        style="min-width: 450px" 
                        v-model="produto.tipo_retirar_lojas_rede" 
                        :disabled="tipo_entrega=='ATO'" 
                        @change="configurarRetirarLojasRedeProduto(produto)">
                        
                        <option value="N" :disabled="tipo_entrega == 'RLR'">Não retirar nas lojas da rede</option>
                        <option value="S">Cliente irá retirar nas lojas da rede posteriormente</option>
                        <option value="I">Cliente irá retirar nas lojas da rede imediatamente</option>
                        <option value="T">Cliente irá retirar nesta loja posteriormente (transferir)</option>
                      
                      </select>
                    </td>
                    
                    <td class="max-width" v-if="!colunas_itens_ocultar.includes('cNome_Empresa_Ret_Lojas_Rede')">
                      <select
                        class="w3-input w3-border w3-block" 
                        style="min-width: 380px" 
                        @change="arrumarGrid(produto, true)" 
                        :disabled="produto.tipo_retirar_lojas_rede == 'N' ||
                        produto.tipo_retirar_lojas_rede == 'T' ||
                        tipo_entrega=='ATO'" 
                        v-model="produto.empresa_retirar_lojas_rede_id">

                        <option value=""/>
                        <option :value="empresa.empresa_id" v-for="empresa in empresas_entrega_loja_rede">
                          {{empresa.empresa_id}} - {{empresa.nome_fantasia}}
                        </option>
                      </select>
                    </td>
                    
                    <td class="w3-center" v-if="!colunas_itens_ocultar.includes('cTipo_Local_Padrao_Entrega_Ato')">
                      <span style="color: #2980b9; font-weight: bold;" v-if="produto.tipo_local_padrao_entrega_ato == 'L'">Loja</span>
                      <span style="color: #27ae60; font-weight: bold;" v-else>Depósito</span>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
            
            <swiper ref="awesomeSwiperA" :options="configuracoes_swiper">
              <swiper-slide style=" min-width: 100%;" class="main">
                <div class="w3-row-padding padding-info" style="padding:0">
                  
                  <div v-if="tipo_entrega == 'ESA'" class="w3-row-padding" style="padding:0">
                    <div class="w3-col s12 m12 l4 w3-margin-top">
                      <label>Tipo de agendamento</label>
                      <select 
                        class="w3-select w3-border" 
                        :disabled="!temQuantidadeAgendar" 
                        v-model="tipo_agendamento_entrega" 
                        @change="buscarDataMinimaEntrega()">
                        <option v-for="tipo in tiposAgendamentoArray" :value="tipo.valor">
                          {{tipo.descricao}}
                        </option>
                      </select>
                    </div>
                    
                    <div class="w3-col s12 m5 l3 w3-margin-top">
                      <label>Dt. min. entrega</label>
                      <input 
                        type="date" class="w3-input w3-border" 
                        :disabled="!temQuantidadeAgendar || 
                        tipo_agendamento_entrega != 'P'" 
                        v-model="data_minima_entrega" 
                        @change="buscarDataMinimaEntrega()">
                    </div>
                    
                    <div class="w3-col s12 m4 l3 w3-margin-top">
                      <label>Dt. entrega</label>
                      <input 
                        type="date" class="w3-input w3-border" 
                        :disabled="!temQuantidadeAgendar || 
                        tipo_agendamento_entrega != 'E'" 
                        v-model="data_entrega">
                    </div>
                    
                    <div class="w3-col s12 m3 l2 w3-margin-top" v-if="parametros_empresa.tipo_agendamento_horario_ent == 'H'">
                      <label>Hora entrega</label>
                      <input 
                        type="text" 
                        class="w3-input w3-border" 
                        v-mask="'##:##'" 
                        :disabled="tipo_agendamento_entrega != 'E'" 
                        v-model="hora_entrega"
                      />
                    </div>
                    
                    <div class="w3-col s12 m3 l2 w3-margin-top" v-if="parametros_empresa.tipo_agendamento_horario_ent == 'P'">
                      <select 
                        class="w3-select w3-border" 
                        style="margin-top: 22px;" 
                        :disabled="tipo_agendamento_entrega != 'E'" 
                        v-model="hora_entrega">
                        <option value="08:00">AM</option>
                        <option value="14:00">PM</option>
                        <option value="">--</option>
                      </select>
                    </div>

                  </div>

                  <div 
                    class="w3-col s12 m6 l6 w3-margin-top" 
                    v-if="aut_definir_tipo_contato_pedido == 'S' && 
                    (tipo_entrega == 'EPG' || tipo_entrega == 'ESA')">

                    <label>Tipo de contato do pedido</label> 
                    <select class="w3-select w3-border" v-model="tipo_contato_cliente">
                      <option value="NEN">Nenhum</option>
                      <option value="ACC">Aguardar contato do cliente</option>
                      <option value="ECC">Entrar em contato com o cliente</option>
                    </select>
                  </div>
                  
                  <div 
                    class="w3-col s12 m6 l6 w3-left"  
                    v-if="parametros_empresa.utiliza_recebimento_entrega == 'S' && 
                    (tipo_entrega == 'EPG' ||
                    tipo_entrega == 'ESA')">

                    <div class="w3-hide-small" style="margin-top: 40px;"/>
                    <div class="w3-hide-large" style="margin-top: 10px;"/>

                    <input
                      id="ckRecebimentoEntrega" 
                      class="w3-check" 
                      v-model="recebimento_na_entrega" 
                      type="checkbox" 
                      :disabled="tipo_entrega == 'ATO'"
                    />
                    <label for="ckRecebimentoEntrega">Recebimento na entrega</label>
                  </div>
              
                </div>
                
                <div class="w3-container" v-if="frete_rota_buscar_entregas_ato.rota">
                
                  <div class="w3-col m12 w3-margin-top">
                    <strong>Rota</strong>
                    <input 
                      type="text" 
                      class="w3-input w3-border" 
                      v-model="frete_rota_buscar_entregas_ato.rota" disabled
                    />
                  </div>
                  
                  <div class="w3-col m6 s12">
                    <strong>Valor do frete por Kg</strong>
                    <input 
                      type="text" 
                      class="w3-input w3-border" 
                      :value="frete_rota_buscar_entregas_ato.valor_frete_por_kg_venda" disabled
                    />
                  </div>
                  
                  <div class="w3-col m6 s12">
                    <strong>Total do frete por Kg</strong>
                    <input 
                      type="text"
                      class="w3-input w3-border" 
                      :value="frete_rota_buscar_entregas_ato.total_frete_rota_kg" disabled
                    />
                  </div>
                  
                  <div class="w3-col m6 s12">
                    <strong>% do frete por valor dos produtos</strong>
                    <input 
                      type="text"
                      class="w3-input w3-border" 
                      :value="frete_rota_buscar_entregas_ato.perc_frete_venda" 
                      disabled
                    />
                  </div>
                  
                  <div class="w3-col m6 s12">
                    <strong>Total do frete por %</strong>
                    <input 
                      type="text" 
                      class="w3-input w3-border" 
                      :value="frete_rota_buscar_entregas_ato.valor_ref_perc_prod_frete_rota" 
                      disabled
                    />
                  </div>
                  
                  <div class="w3-col m12 s12">
                    <strong>Valor mínimo do frete para esta rota</strong>
                    <input 
                      type="text" 
                      class="w3-input w3-border" 
                      :value="frete_rota_buscar_entregas_ato.valor_minimo_frete_venda" 
                      disabled
                    />
                  </div>
        
                  <div class="w3-col m12 s12">
                    <strong>Valor do frete de rota a ser cobrado</strong>
                    <input 
                      type="text" 
                      class="w3-input w3-border" 
                      :value="frete_rota_buscar_entregas_ato.valor_frete_rota_cobrado" 
                      disabled
                    />
                  </div>
                  
                  <div class="w3-col m12 s12">
                    <strong>Total do frete terceirizado</strong>
                    <input 
                      type="text" 
                      class="w3-input w3-border" 
                      :value="frete_rota_buscar_entregas_ato.total_frete_terceirizado" 
                      disabled
                    />
                  </div>
                </div>

                <div class="card-botao-mostrar-veiculos w3-container w3-border w3-padding-small" v-if="frete_tipos_veiculos_buscar_entregas_ato.length > 0">

                  <h6
                    class="w3-hide-large fundo-veiculos-transporte"
                    v-if="existe_frete_com_valor"
                    @click="mostrar_veiculos_transporte = !mostrar_veiculos_transporte">&nbsp;
                    <span>
                      <i v-if="mostrar_veiculos_transporte" class="fas fa-sort"/>
                      <i v-if="!mostrar_veiculos_transporte" class="fas fa-sort-up"/>
                    </span>&nbsp;
                    <i class="fas fa-truck" /> 
                    &nbsp;&nbsp;&nbsp;
                    <a href="#"> Veículos de transporte</a> 
                  </h6>

                  <div 
                    v-show="!mostrar_veiculos_transporte" 
                    class="w3-hide-large w3-col s12 w3-center" 
                    @click="mostrar_veiculos_transporte = !mostrar_veiculos_transporte">
                    <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"/>
                  </div>

                  <div 
                    class="w3-container w3-hide-large" 
                    v-if="
                    ( 
                      (mostrar_veiculos_transporte) &&
                      (tipo_entrega != 'ATO' || tipo_entrega !='RLR') &&
                      (frete_tipos_veiculos_buscar_entregas_ato.length > 0) 
                    )">
                    
                    <div class="w3-responsive w3-margin-top w3-col">
                      <div 
                        class="label-clicavel card-tipo-veiculo w3-border"
                        style="margin-bottom: 8px; margin-right: 5px;" 
                        v-for="tipo_veiculo in frete_tipos_veiculos_buscar_entregas_ato" 
                        v-show="parseFloat(tipo_veiculo.valor_frete) > 0"
                        :key="tipo_veiculo.tipo_veiculo_id">

                        <div>Tipo de veículo: <strong>{{tipo_veiculo.tipo_veiculo_id}}</strong></div>
                        <div>Nome: <strong>{{tipo_veiculo.nome}}</strong></div>
                        <div>Peso máximo: <strong>{{tipo_veiculo.peso_maximo}} Kg</strong></div>
                        <div>Total: <strong>R${{formatarValor(tipo_veiculo.valor_frete, 2)}}</strong></div>
                      
                        <div 
                          style="min-width: 200px">
                          Quantidade de viagens: 
                          <input 
                            type="number" 
                            step="1" 
                            class="w3-input w3-border" 
                            v-model="tipo_veiculo.viagens" v-on:keyup="calcularFreteTiposVeiculos()"
                          />
                        </div>
                        
                        <div 
                          class="alinhamento-numero" 
                          style="min-width: 200px; color: #199436; margin-top: 3px;"> 
                          <strong> R$ {{formatarValor(tipo_veiculo.valor_total, 2)}} </strong>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                
                <div 
                  class="w3-container w3-hide-small w3-hide-medium" 
                  v-if="frete_tipos_veiculos_buscar_entregas_ato.length > 0 && 
                  (tipo_entrega != 'ATO' || tipo_entrega !='RLR')">

                  <div class="w3-responsive w3-margin-top">
                    <table class="w3-table-all w3-striped w3-border">
                      
                      <thead>
                        <tr>
                          <th class="alinhamento-numero">Tipo de veículo</th>
                          <th>Nome</th>
                          <th class="alinhamento-numero">Peso máximo</th>
                          <th class="alinhamento-numero">Valor do frete</th>
                          <th class="alinhamento-numero">Quantidade de viagens</th>
                          <th class="alinhamento-numero">Total</th>
                        </tr>
                      </thead>
                      
                      <tbody>
                        <tr class="label-clicavel" v-for="tipo_veiculo in frete_tipos_veiculos_buscar_entregas_ato" v-show="parseFloat(tipo_veiculo.valor_frete) > 0">
                          <td class="alinhamento-numero">{{tipo_veiculo.tipo_veiculo_id}}</td>
                          <td>{{tipo_veiculo.nome}}</td>
                          <td class="alinhamento-numero">{{tipo_veiculo.peso_maximo}} Kg</td>
                          <td class="alinhamento-numero">R$ {{formatarValor(tipo_veiculo.valor_frete, 2)}}</td>
                          <td style="min-width: 200px">
                            <input 
                              type="number" 
                              step="1" 
                              class="w3-input w3-border" 
                              v-model="tipo_veiculo.viagens" 
                              v-on:keyup="calcularFreteTiposVeiculos()"
                            />
                          </td>
                          <td class="alinhamento-numero" style="min-width: 200px">R$ {{formatarValor(tipo_veiculo.valor_total, 2)}}</td>
                        </tr>
                      </tbody>

                    </table>
                  </div>
                </div>
                
                <div class="w3-container">
                  <div class="w3-col s12 l4 w3-margin-top w3-right total-produtos">
                    <div class="w3-col">
                      <label class="w3-col m5 l6">Total fretes</label>
                      <input 
                        type="text" 
                        class="w3-input total-produtos-entrega frete w3-col m7 l6" 
                        style="text-align:right" 
                        :value="formatarValor(valorTotalFretes, 2)" disabled
                      />
                    </div>
                    
                    <div class="w3-col">
                      <label class="w3-col m5 l6">Peso dos produtos para entrega</label>
                      <input 
                        type="text" 
                        class="w3-input total-produtos-entrega frete w3-col m7 l6" 
                        style="text-align:right" 
                        :value="formatarValor(total_peso, 2)" disabled>
                    </div> 
                    
                    <div class="w3-col">
                      <label class="w3-col m5 l6">Total dos produtos para entrega</label>
                      <input 
                        type="text" 
                        class="w3-input total-produtos-entrega w3-col m7 l6" 
                        style="text-align:right" 
                        :value="formatarValor(tot_valor_entregar, 2)" disabled
                      />
                    </div>
                  </div>
                </div>
                
                <div class="w3-row w3-margin" style="margin-bottom: 5px">
                  <div class="w3-left">
                    <button 
                      class="w3-button w3-theme"
                      @click="cancelarBuscarEntregasNoAto()">
                      <i class="fas fa-times-circle"/> Cancelar
                    </button>
                  </div>
                  <div class="w3-right">
                    <button 
                      class="w3-button w3-green"
                      @click="gravar()">
                      <i class="fas fa-check-circle"/> Ok
                    </button>
                  </div>
                </div>
              </swiper-slide>
            </swiper>

            <!-- Inicio modal de retirar lojas rede --> 
            <div id="modal-retirar" class="w3-modal" v-show="modal_retirar_tipo_item" style="display:block;">
              <div class="w3-modal-content">
                <span @click="modal_retirar_tipo_item = false" class="w3-button w3-display-topright">&times;</span>
                <div>
                  <span 
                    class="w3-padding-small"  
                    @click="tipoRetirarLojasRede(produto_selecionado_editando, 'N')" 
                    v-show="produto_selecionado_editando.tipo_retirar_lojas_rede != 'N' && tipo_entrega !== 'RLR'">
                    <i class="far fa-circle"></i>&nbsp;
                    Não retirar nas lojas da rede
                  </span>
                  
                  <span class="w3-padding-small" v-show="produto_selecionado_editando.tipo_retirar_lojas_rede == 'N'">
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Não retirar nas lojas da rede
                  </span>
                </div>
              
                <div>
                  <span 
                    class="w3-padding-small" 
                    @click="tipoRetirarLojasRede(produto_selecionado_editando, 'I')" 
                    v-show="produto_selecionado_editando.tipo_retirar_lojas_rede != 'I'">
                    <i class="far fa-circle"></i>&nbsp;
                    Imediatamente
                  </span>
                  
                  <span class="w3-padding-small" v-show="produto_selecionado_editando.tipo_retirar_lojas_rede == 'I'" >
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Imediatamente
                  </span>
                </div>
              
                <div>
                  <span class="w3-padding-small" @click="tipoRetirarLojasRede(produto_selecionado_editando, 'S')" v-show="produto_selecionado_editando.tipo_retirar_lojas_rede != 'S'">
                    <i class="far fa-circle"></i>&nbsp;
                    Posteriormente
                  </span>
                  
                  <span class="w3-padding-small" v-show="produto_selecionado_editando.tipo_retirar_lojas_rede == 'S'">
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Posteriomente
                  </span>
                </div>
              
                <div>
                  <span class="w3-padding-small" @click="tipoRetirarLojasRede(produto_selecionado_editando, 'T')" v-show="produto_selecionado_editando.tipo_retirar_lojas_rede !='T'">
                    <i class="far fa-circle"></i>&nbsp;
                    Posteriomente (Transferir)
                  </span>
                  
                  <span class="w3-padding-small" v-show="produto_selecionado_editando.tipo_retirar_lojas_rede == 'T'">
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Posteriormente (Transferir)
                  </span>
                </div>
                
                <div class="w3-margin-bottom" v-show="!colunas_itens_ocultar.includes('cNome_Empresa_Ret_Lojas_Rede') || tipo_entrega === 'RLR'">
                  <div class="w3-dropdown-hover" v-show="produto_selecionado_editando.tipo_retirar_lojas_rede == 'I' || produto_selecionado_editando.tipo_retirar_lojas_rede == 'S' ">
                    <button class="w3-button">Selecionar empresa</button>
                    <div class="w3-dropdown-content w3-bar-block w3-border">
                      <div @click="produto_selecionado_editando.empresa_retirar_lojas_rede_id = empresa.empresa_id" class="w3-bar-item w3-button" v-for="empresa in empresas_entrega_loja_rede" :key="empresa.empresa_id">
                        <span @click="modal_retirar_tipo_item = false">{{empresa.empresa_id}} - {{empresa.nome_fantasia}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    
            <!-- Inicio modal de definir lote de produto  --> 
            <div id="modalDefinirLoteProduto" class="w3-modal" v-if="abrirModalDefinirLoteProduto" @click="abrirModalDefinirLoteProduto = false" style="display: block">
              <div class="w3-modal-content w3-animate-zoom" @click.stop>
                <header class="w3-container">
                  <span @click="abrirModalDefinirLoteProduto = false" class="w3-button w3-display-topright">&times;</span>
                  <h2 class="texto-vermelho w3-center">{{formatarValor(produto_selecionado_editando.produto_id, 0)}} - {{produto_selecionado_editando.nome}}</h2>
                </header>
                
                <div class="w3-container w3-hide-large">
                  <div style="max-height: calc(75vh - 100px); min-height: 200px; overflow: auto">
                    <div v-show="divisoes_lotes_produto_selecionado.length > 0" v-for="divisao in divisoes_lotes_produto_selecionado">
                      <div class="w3-panel w3-card card-lote w3-col s12 m12 l12" style="cursor: pointer">
                        
                        <div class="w3-col s12 m12 l12">
                          <label class="w3-margin-right">
                            Empresa: <strong>{{divisao.nome_empresa}}</strong>
                          </label>
                        </div>

                        <div class="w3-col s12 m12 l12">
                          <label class="w3-margin-right">
                            Local: <strong>{{divisao.local_id}} - {{divisao.nome_local}}</strong>
                          </label>
                        </div>

                        <div class="w3-col s12 m12 l12">
                          <label class="w3-margin-right">
                            Lote: <strong>{{divisao.lote}}</strong>
                          </label>
                        </div>

                        <div class="w3-col s12 m12 l12">
                          <label class="w3-margin-right">
                            Estoque disponível: <strong>{{divisao.estoque_disponivel}}</strong>
                          </label>
                        </div>

                        <div class="w3-col s12 m12 l12">
                          <label class="w3-margin-right">
                            Múlt. venda ponta estoque: <strong>{{divisao.multiplo_venda_ponta}}</strong>
                          </label>
                        </div>

                        <div class="w3-col s12 m12 l12" v-if="divisao.vencimento">
                          <label class="w3-margin-right">
                            Vencimento: <strong>{{divisao.vencimento}}</strong>
                          </label>
                        </div>

                        <div class="w3-col s12 m12 l12" v-if="divisao.fabricacao">
                          <label class="w3-margin-right">
                            Fabricação: <strong>{{divisao.fabricacao}}</strong>
                          </label>
                        </div>
                        
                        <div class="w3-col s12 m12 l12" v-if="(produto_selecionado_editando.quantidade_entrega_ato > 0)">
                          <label class="w3-margin-right">Qtd. entregar no ato:</label>
                          <vue-numeric 
                            style="min-width: 100px" 
                            class="w3-input w3-border w3-center" 
                            v-bind:precision="2" 
                            separator="." 
                            v-model="divisao.quantidade_utilizar_ato" 
                            @input="totalizarDivisoesProdutoSelecionado"
                          />
                        </div>

                        <div class="w3-col s12 m12 l12" v-if="(tipo_entrega !== 'ATO') && (produto_selecionado_editando.quantidade_agendar > 0)">
                          <label class="w3-margin-right">Qtd. agendar:</label>
                          <vue-numeric 
                            style="min-width: 100px" 
                            class="w3-input w3-border w3-center" 
                            v-bind:precision="2" 
                            separator="." 
                            v-model="divisao.quantidade_agendar" 
                            @input="totalizarDivisoesProdutoSelecionado"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              
                <div class="w3-container">
                  <div class="w3-responsive w3-hide-small w3-hide-medium">
                    <table class="w3-table-all">
                      <thead>
                        <tr>  
                          <th>Empresa</th>
                          <th>Local</th>
                          <th>Lote</th>
                          <th class="alinhamento-numero">Est. disponível</th>
                          <th>Qtd. util. ent. ato</th>
                          <th>Qtd. util. ent. prog.</th>
                          <th class="alinhamento-numero">Mult. vend. ponta est.</th>
                          <th>Vencimento</th>
                          <th>Fabricação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="divisao in divisoes_lotes_produto_selecionado" >
                          <td>{{divisao.nome_empresa}}</td>
                          <td>{{divisao.local_id}} - {{divisao.nome_local}}</td>
                          <td>{{divisao.lote}}</td>
                          <td class="alinhamento-numero">{{divisao.estoque_disponivel}}</td>
                          
                          <td>
                            <vue-numeric 
                              :disabled="!produto_selecionado_editando.quantidade_entrega_ato > 0" 
                              style="min-width: 100px" 
                              class="w3-input w3-border" 
                              v-bind:precision="3" 
                              separator="." 
                              v-model="divisao.quantidade_utilizar_ato" 
                              @input="totalizarDivisoesProdutoSelecionado"
                            />
                          </td>

                          <td>
                            <vue-numeric 
                              style="min-width: 100px" 
                              class="w3-input w3-border" 
                              v-bind:precision="3" 
                              separator="." 
                              :disabled="!produto_selecionado_editando.quantidade_agendar > 0" v-model="divisao.quantidade_agendar" 
                              @input="totalizarDivisoesProdutoSelecionado"
                            />
                          </td>

                          <td class="alinhamento-numero">{{divisao.multiplo_venda_ponta}}</td>
                          <td>{{divisao.vencimento}}</td>
                          <td>{{divisao.fabricacao}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                
                  <div class="container">
                    <div class="w3-row-padding">
                      <div class="w3-half">
                        <strong>Total entrega no ato: </strong>
                        {{formatarValor(produto_selecionado_editando.quantidade_entrega_ato, 3)}}
                      </div>
                      <div class="w3-half">
                        <strong>Total definido entrega no ato: </strong>
                        {{formatarValor(totalizador_divisoes_produto_selecionado.quantidade_utilizar_ato, 3)}}
                      </div>
                      <div class="w3-half" >
                        <strong>Total agendar: </strong>
                        {{formatarValor(produto_selecionado_editando.quantidade_agendar, 3)}}
                      </div>
                      <div class="w3-half">
                        <strong>Total definido agendar: </strong>
                        {{formatarValor(totalizador_divisoes_produto_selecionado.quantidade_agendar, 3)}}
                      </div>
                    </div>
                  </div>
                  <footer class="w3-container w3-center" style="padding: 0;">
                    <button
                      class="w3-button w3-theme" 
                      style="margin-top: 10px; margin-bottom:10px" 
                      v-on:click="definirLotesProdutoSelecionado"> 
                      <i class="fas fa-check-circle"></i> Aplicar
                    </button>
                  </footer>
                </div>
              </div>
            
            </div>  
            <!-- Fim modal de definir lote de produto -->
            
            <!-- Inicio tipo retirar lojas rede  --> 
            <div id="modalTipoRetirarLojasRede" class="w3-modal" v-if="abrirModalTipoRetirarLojasRede" @click="cancelarSelecaoTipoRetirarLojasRede"  style="display: block">
              <div class="w3-modal-content w3-animate-zoom" @click.stop>
                <header class="w3-container">
                  <span 
                    @click="cancelarSelecaoTipoRetirarLojasRede" 
                    @change="nova_empresa_retirar_lojas_rede_id = ''" 
                    class="w3-button w3-display-topright">&times;
                  </span>
                  <h2 class="texto-vermelho w3-center">Tipo de retirar lojas rede</h2>
                </header>
                
                <div class="w3-padding-small"  @click="novo_tipo_retirar_lojas_rede = 'N'">
                  <span 
                    v-if="novo_tipo_retirar_lojas_rede != 'N' &&
                    tipo_entrega !== 'RLR'">
                    <i class="far fa-circle"></i>&nbsp;
                    Não retirar nas lojas da rede
                  </span>
                  <span 
                    v-if="novo_tipo_retirar_lojas_rede == 'N'">
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Não retirar nas lojas da rede
                  </span>
                </div>
                      
                <div class="w3-padding-small" @click="novo_tipo_retirar_lojas_rede = 'I'">
                  <span 
                    v-if="novo_tipo_retirar_lojas_rede != 'I'">
                    <i class="far fa-circle"></i>&nbsp;
                    Imediatamente
                  </span>
                  
                  <span 
                    class="w3-padding-small" 
                    v-if="novo_tipo_retirar_lojas_rede == 'I'">
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Imediatamente
                  </span>
                </div>
                      
                <div class="w3-padding-small"  @click="novo_tipo_retirar_lojas_rede = 'S'">
                  <span v-if="novo_tipo_retirar_lojas_rede != 'S'">
                    <i class="far fa-circle"></i>&nbsp;
                    Posteriormente
                  </span>
                  <span  v-if="novo_tipo_retirar_lojas_rede == 'S'">
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Posteriomente
                  </span>
                </div>
                      
                <div class="w3-padding-small"  @click="novo_tipo_retirar_lojas_rede = 'T'" >
                  <span v-if="novo_tipo_retirar_lojas_rede !='T'">
                    <i class="far fa-circle"></i>&nbsp;
                    Posteriomente (Transferir)
                  </span>
                  
                  <span  v-if="novo_tipo_retirar_lojas_rede =='T'">
                    <i class="fas fa-check texto-verde"></i>&nbsp;
                    Posteriormente (Transferir)
                  </span>
                </div>
                
                <div class="w3-margin-bottom" v-if="!colunas_itens_ocultar.includes('cNome_Empresa_Ret_Lojas_Rede') || tipo_entrega === 'RLR'">
                  <div class="w3-dropdown-hover"  v-if="novo_tipo_retirar_lojas_rede =='I' || novo_tipo_retirar_lojas_rede =='S'">
                    <button class="w3-button">Selecionar empresa</button>
                    
                    <div class="w3-dropdown-content w3-bar-block w3-border">
                      <div 
                        @click="nova_empresa_retirar_lojas_rede_id = empresa.empresa_id"
                        class="w3-bar-item w3-button" 
                        v-for="empresa in empresas_entrega_loja_rede">
                        <span v-on:click="configurarRetirarLojasRedeProdutosSelecionados">
                          {{empresa.empresa_id}} - {{empresa.nome_fantasia}}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
                
                <div class="w3-row-padding w3-center">
                  <div class="w3-col s12">
                    <footer class="w3-container w3-center w3-margin-top">
                      <button class="w3-button w3-green" v-on:click="configurarRetirarLojasRedeProdutosSelecionados">
                        <i class="fas fa-check-circle"></i>&nbsp;
                        Ok
                      </button>
                      <button class="w3-button w3-border w3-theme" @click="cancelarSelecaoTipoRetirarLojasRede">
                        <i class="fas fa-times-circle"></i>&nbsp;
                        Cancelar
                      </button>
                    </footer>
                  </div>
                </div>
              </div>
            </div>  
            <!-- Fim modal de tipo retirar lojas rede -->  
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import moment from 'moment'
  import VueNumeric from 'vue-numeric'
  import Legenda from '@/components/Legendas'
  import REntrega from '@/components/Rest/REntrega.js'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import ExibirProcessando from '@/components/ExibirProcessando'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import REstoqueBuscarDivisaoEstoque from '@/components/Rest/REstoque/REstoqueBuscarDivisaoEstoque.js'
  import ROrcamentoBuscarFretePorRota  from '@/components/Rest/ROrcamento/ROrcamentoBuscarFretePorRota.js'
  import ROrcamentoBuscarEntregasNoAto from '@/components/Rest/ROrcamento/ROrcamentoBuscarEntregasNoAto.js'
  import REstoqueBuscarDivisaoEstoqueAutomatico from '@/components/Rest/REstoque/REstoqueBuscarDivisaoEstoqueAutomatico.js'

  export default {
  name: 'BuscarEntregasNoAto',

  props: [
    'vendedor', 
    'tipo_entrega', 
    'produtos_selecionados',   
    'valor_frete', 
    'frete_adicional_andar', 
    'frete_rota', 
    'frete_tipos_veiculos', 
    'tipo_frete', 
    'bairro_entrega_id', 
    'definicoes_lotes',
    'cliente',
    'condicao_pagamento',
    'valor_frete_andar_elevador_escada',
    'valor_frete_manual',
    'data_agendamento'
  ],

  mixins:[formatarValorMixin],

  components: {
    swiper,
    Legenda,
    VueNumeric,
    swiperSlide, 
    ExibirProcessando
  },

  watch:{
    abrirModalDefinirLoteProduto() {
      this.verificarModalAberto();
    },

    abrirModalTipoRetirarLojasRede(){
      this.verificarModalAberto();
    }
  },

  data() {
    return {
      // Variáveis de controle
      api: process.env.API,
      processando: false,
      visivel: false,
      existe_frete_com_valor: false,
      colunas_itens_ocultar: [],
      mixins:[formatarValorMixin],
      novo_tipo_retirar_lojas_rede: '',
      nova_empresa_retirar_lojas_rede_id: '',
      abrirModalDefinirLoteProduto: false,
      abrirModalTipoRetirarLojasRede: false,
      todos_marcados: false,
      modal_retirar_tipo_item: false,
      valor_invalido: false,
      mostrar_veiculos_transporte: false,
      // Configuracoes
      configuracoes_swiper: { 
        noSwipingClass: 'main', 
        zoom: true, 
        autoHeight: true 
      },

    // Parâmetros
      tipo_local_padrao_entrega_ato: '',
      opcao_items_selecionados: '',
      aut_definir_tipo_contato_pedido: '',
    
      parametros_empresa: {},
      parametros_gerais: {},
    
      opcao_loja: '',
      empresas_entrega_loja_rede: [],

      produto_selecionado_editando: {},
      
      // Dados
      produtos_entrega_no_ato: [],
      produto_selecionado: {},
      divisoes_lotes_produto_selecionado: [],
      recebimento_na_entrega: false,
      tipo_contato_cliente: 'NEN',

      total_peso_maximo: 0,
      cRlr_Nao: '',
      cRlr_Sim: 'Sim',
      cRlr_Imediatamente: 'Imediat.',
      cRlr_Transf_Loja_Venda: 'Tran.loj.vda',
      qtd_agendar: 0,
      qtd_sem_agendamento: 0,
      tot_valor_entregar: 0,
      total_peso: 0,
      total_fretes: 0,

      frete_rota_buscar_entregas_ato: [],
      frete_tipos_veiculos_buscar_entregas_ato: [],
      valor_frete_buscar_entregas_ato: 0,
      frete_adicional_andar_buscar_entregas_ato: 0,
      valor_anterior_valor_frete_buscar_entregas_ato: 0,
      valor_anterior_frete_adicional_andar_buscar_entregas_ato: 0,
      definicoes_lotes_buscar_entregas_ato: [],
      totalizador_divisoes_produto_selecionado: {
        quantidade_utilizar_ato: 0,
        quantidade_agendar: 0
      },
      tipo_agendamento_entrega: '',
      tiposAgendamentoArray: [],
      hora_entrega: '',
      data_entrega: '',
      data_minima_entrega: '',
  
      qtd_pendente: 0,
      qtd_sem_agendamento: 0,
    }
  },
  computed: {
    valorTotalFretesTerceirizados(){

      let total = 0;
      if (this.frete_rota_buscar_entregas_ato.total_frete_terceirizado != undefined){
        total += parseFloat(this.strPadraoToNumber(this.frete_rota_buscar_entregas_ato.total_frete_terceirizado));
      }

      for (let i = 0; i < this.frete_tipos_veiculos_buscar_entregas_ato.length; i++) {
        if (this.frete_tipos_veiculos_buscar_entregas_ato[i].viagens > 0) {
          total += this.frete_tipos_veiculos_buscar_entregas_ato[i].valor_total;
        }
      }

      return total;
    },

    valorTotalFretes(){
      let total = 0;

      if (this.tipo_entrega == 'ESA' || this.tipo_entrega == 'EPG'){
        if (this.tipo_frete != 'C') {
          total += this.valorTotalFretesTerceirizados + this.frete_adicional_andar_buscar_entregas_ato + this.valor_frete_manual;
        }
      }
      
      if (total < 0){ 
        total = 0;
      }

      if (!this.temQuantidadeAgendar){
        total = 0;  
      }

      return total;
    },

    temQuantidadeAgendar: function(){
      let tem_qtd_agendar = false;

      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        tem_qtd_agendar = this.produtos_entrega_no_ato[i].quantidade_agendar > 0;
        
        if (tem_qtd_agendar){
          break;
        }
      }

      return tem_qtd_agendar;
    },
  },
  
  async mounted() {
   
  },

  methods: {
    async abrir(){
      try {
        let local_padrao_itens = "";
        this.processando = true;
        this.tipo_local_padrao_entrega_ato = this.vendedor.tipo_local_padrao_entrega_ato;
  
        let produtos = JSON.parse(JSON.stringify(this.produtos_selecionados))
        for (let i = 0; i < produtos.length; i++) {
          produtos[i].ponta_estoque = produtos[i].ponta_estoque ? 'S' : 'N';
          produtos[i].retirar_lojas_rede = this.tipo_entrega == 'RLR' ? 'S' : 'N';
          produtos[i].preco_venda = produtos[i].preco;
          produtos[i].quantidade = this.formatarValor(produtos[i].quantidade);
        }
        
        let parametros = {
          itens_orcamento: produtos,
          tipo_entrega: this.tipo_entrega,
          tipo_local_padrao_entrega_ato: this.tipo_local_padrao_entrega_ato
        }
        let retorno = await ROrcamentoBuscarEntregasNoAto.buscarEntregasNoAtoDadosIniciais(this.axios, parametros);
  
        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        // Convertanto campos para valor numérico
        for (let i in retorno.dados.empresas_entrega_loja_rede) {
          retorno.dados.empresas_entrega_loja_rede[i].empresa_id = Biblioteca.valorInt(retorno.dados.empresas_entrega_loja_rede[i].empresa_id);
        }

        // Convertanto campos para valor numérico
        for (let i in retorno.dados.itens_entrega_ato) {
          retorno.dados.itens_entrega_ato[i].produto_id = Biblioteca.valorInt(retorno.dados.itens_entrega_ato[i].produto_id);
          retorno.dados.itens_entrega_ato[i].item_id = Biblioteca.valorInt(retorno.dados.itens_entrega_ato[i].item_id);
          retorno.dados.itens_entrega_ato[i].quantidade_pedida = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].quantidade_pedida);
          retorno.dados.itens_entrega_ato[i].quantidade_entrega_ato = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].quantidade_entrega_ato);
          retorno.dados.itens_entrega_ato[i].quantidade_entrega_ato_dep = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].quantidade_entrega_ato_dep);
          retorno.dados.itens_entrega_ato[i].quantidade_entrega_ato_exp = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].quantidade_entrega_ato_exp);
          retorno.dados.itens_entrega_ato[i].quantidade_agendar = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].quantidade_agendar);
          retorno.dados.itens_entrega_ato[i].quantidade_sem_agendamento = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].quantidade_sem_agendamento);
          retorno.dados.itens_entrega_ato[i].estoque_loja = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].estoque_loja);
          retorno.dados.itens_entrega_ato[i].estoque_rede = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].estoque_rede);
          retorno.dados.itens_entrega_ato[i].transf_pendentes_rede = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].transf_pendentes_rede);
          retorno.dados.itens_entrega_ato[i].multiplo_venda = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].multiplo_venda);
          retorno.dados.itens_entrega_ato[i].quantidade_venda = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].quantidade_venda);
          retorno.dados.itens_entrega_ato[i].tinta_base_id = Biblioteca.valorInt(retorno.dados.itens_entrega_ato[i].tinta_base_id);
          retorno.dados.itens_entrega_ato[i].peso = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].peso);
          retorno.dados.itens_entrega_ato[i].preco_venda = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].preco_venda);
          retorno.dados.itens_entrega_ato[i].empresa_retirar_lojas_rede_id = Biblioteca.valorInt(retorno.dados.itens_entrega_ato[i].empresa_retirar_lojas_rede_id);
          retorno.dados.itens_entrega_ato[i].qtd_min_piso_transformar_ponta = Biblioteca.valor(retorno.dados.itens_entrega_ato[i].qtd_min_piso_transformar_ponta);
          retorno.dados.itens_entrega_ato[i].qtd_dias_entrega_produto = Biblioteca.valorInt(retorno.dados.itens_entrega_ato[i].qtd_dias_entrega_produto);
          retorno.dados.itens_entrega_ato[i].prazo_entrega_fornecedor = Biblioteca.valorInt(retorno.dados.itens_entrega_ato[i].prazo_entrega_fornecedor); 
          retorno.dados.itens_entrega_ato[i].selecionado = false;
        }

        // Convertanto campos para valor numérico
        for (let i in this.definicoes_lotes) {
          this.definicoes_lotes[i].produto_id = Biblioteca.valorInt(this.definicoes_lotes[i].produto_id);
          this.definicoes_lotes[i].empresa_id = Biblioteca.valorInt(this.definicoes_lotes[i].empresa_id);
          this.definicoes_lotes[i].local_id = Biblioteca.valorInt(this.definicoes_lotes[i].local_id);
          this.definicoes_lotes[i].estoque_disponivel = Biblioteca.valor(this.definicoes_lotes[i].estoque_disponivel);
          this.definicoes_lotes[i].multiplo_venda = Biblioteca.valor(this.definicoes_lotes[i].multiplo_venda);
          this.definicoes_lotes[i].multiplo_venda_ponta = Biblioteca.valor(this.definicoes_lotes[i].multiplo_venda_ponta);
          this.definicoes_lotes[i].quantidade_agendar = Biblioteca.valor(this.definicoes_lotes[i].quantidade_agendar);
          this.definicoes_lotes[i].quantidade_ent_ato = Biblioteca.valor(this.definicoes_lotes[i].quantidade_ent_ato);
          this.definicoes_lotes[i].quantidade_utilizar_ato = Biblioteca.valor(this.definicoes_lotes[i].quantidade_utilizar_ato);
        }

        // Alimentando variavéis com o retorno da requisição
        this.empresas_entrega_loja_rede = retorno.dados.empresas_entrega_loja_rede;
        this.parametros_empresa = retorno.dados.parametros_empresa;
        this.parametros_gerais = retorno.dados.parametros_gerais;      
        this.aut_definir_tipo_contato_pedido = retorno.dados.aut_definir_tipo_contato_pedido;
        this.data_entrega = this.data_agendamento;
        this.produtos_entrega_no_ato = retorno.dados.itens_entrega_ato;
        this.definicoes_lotes_buscar_entregas_ato = this.definicoes_lotes;
        
        this.tiposAgendamentoEntrega();

        for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
          this.produtos_entrega_no_ato[i].nome = produtos[i].nome;
          this.arrumarGrid(this.produtos_entrega_no_ato[i], (i == this.produtos_entrega_no_ato.length - 1));
          if(parseFloat(this.produtos_entrega_no_ato[i].valor_frete) > 0){
            this.existe_frete_com_valor = true;
          }
          
        }
  
        if (this.parametros_empresa.tipo_selec_local_entrega_ato == 'N') {
          this.colunas_itens_ocultar.push(...['cQuantidade_Pedida', 'cQuantidade_Entrega_Ato_Dep', 'cQuantidade_Entrega_Ato_Exp']);
        } else {
          if (this.tipo_entrega != 'ATO')
          this.colunas_itens_ocultar.push('cQuantidade_Pedida');  
        }
        
        if (this.tipo_entrega != 'ESA') {
          this.colunas_itens_ocultar.push(...['cQuantidade_Sem_Agendamento', 'cData_Prevista_Entrega']);
        }
    
        if (this.vendedor.tipo_local_padrao_entrega_ato == 'N'){
          this.colunas_itens_ocultar.push('cTipo_Local_Padrao_Entrega_Ato');
        }
    
        if (this.parametros_gerais.perm_selec_emp_ven_ret_loj_red != 'S'){
          this.colunas_itens_ocultar.push('cNome_Empresa_Ret_Lojas_Rede');
        }
  
        this.frete_rota_buscar_entregas_ato = Object.assign({}, this.frete_rota);
        this.frete_tipos_veiculos_buscar_entregas_ato = JSON.parse(JSON.stringify(this.frete_tipos_veiculos));
        this.valor_frete_buscar_entregas_ato = this.valor_frete;
        this.frete_adicional_andar_buscar_entregas_ato = this.frete_adicional_andar;
    
        this.valor_anterior_valor_frete_buscar_entregas_ato = this.valor_frete;
        this.valor_anterior_frete_adicional_andar_buscar_entregas_ato = this.frete_adicional_andar;
    
        this.ajustarValorTotalFrete();
  
        this.processando = false;
        this.visivel = true;
      } catch (error) {
        this.visivel = false;
        this.verificarErro(error, 'mounted');
      }
    },
    tipoRetirarLojasRede(produto, tipo){
      produto.tipo_retirar_lojas_rede = tipo;

      if (produto.tipo_retirar_lojas_rede !== 'N'){
        produto.quantidade_agendar = produto.quantidade_venda;
        produto.quantidade_sem_agendamento = 0;
        produto.quantidade_entrega_ato = 0;
        produto.quantidade_entrega_ato_dep = 0;
        produto.quantidade_entrega_ato_exp = 0;
      }

      let index = -1;
      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        if (this.produtos_entrega_no_ato[i].produto_id == produto.produto_id){
          index = i;
          break;
        }
      }

      if (index === -1){
        Biblioteca.exclamar('Produto não encontrado!');
        return;
      }

      this.produtos_entrega_no_ato[index] = produto;
      this.arrumarGrid(this.produtos_entrega_no_ato[index], true);
      this.$forceUpdate();
    },
   
    ativarDesativarProdutoSelecionado(produto, tipo){
      
      if(tipo === 'Pedida'){
        produto.quantidade_pedida = produto.quantidade_venda;
        produto.quantidade_sem_agendamento = 0;
        produto.quantidade_entrega_ato = 0
        produto.quantidade_entrega_ato_dep = 0;
        produto.quantidade_entrega_ato_exp = 0;
        produto.quantidade_agendar = 0;
      } else if(tipo === 'Retirar ato'){
        produto.quantidade_entrega_ato = produto.quantidade_venda;
        produto.quantidade_sem_agendamento = 0;
        produto.quantidade_entrega_ato_dep = 0;
        produto.quantidade_entrega_ato_exp = 0;
        produto.quantidade_agendar = 0;
        produto.selecionado = true;
        produto.tipo_retirar_lojas_rede = 'N';
      } else if(tipo === 'Entrega dep'){
        produto.quantidade_entrega_ato_dep = produto.quantidade_venda;
        produto.quantidade_sem_agendamento = 0;
        produto.quantidade_entrega_ato = 0;
        produto.quantidade_entrega_ato_exp = 0;
        produto.quantidade_agendar = 0;
        produto.selecionado = true;
        produto.tipo_retirar_lojas_rede = 'N';
      } else if(tipo === 'Entrega exp'){
        produto.quantidade_entrega_ato_exp = produto.quantidade_venda;
        produto.quantidade_sem_agendamento = 0;
        produto.quantidade_entrega_ato = 0;
        produto.quantidade_entrega_ato_dep = 0;
        produto.quantidade_agendar = 0;
        produto.selecionado = true;
        produto.tipo_retirar_lojas_rede = 'N';
      } else if(tipo == 'agendar'){
        produto.quantidade_agendar = produto.quantidade_venda;
        produto.quantidade_sem_agendamento = 0;
        produto.quantidade_entrega_ato = 0;
        produto.quantidade_entrega_ato_dep = 0;
        produto.quantidade_entrega_ato_exp = 0;
      } else if(tipo === 'rede'){
        produto.quantidade_agendar = produto.quantidade_venda;
        produto.quantidade_sem_agendamento = 0;
        produto.quantidade_entrega_ato = 0;
        produto.quantidade_entrega_ato_dep = 0;
        produto.quantidade_entrega_ato_exp = 0;
        produto.tipo_retirar_lojas_rede = 'S';
      }else{
        produto.quantidade_sem_agendamento = produto.quantidade_venda;
        produto.quantidade_agendar  = 0;
        produto.quantidade_entrega_ato = 0;
        produto.quantidade_entrega_ato_dep = 0;
        produto.quantidade_entrega_ato_exp = 0;
      }

      this.arrumarGrid(produto, true);
      return produto;
    },
    
    ativarCard(produto){
      this.$forceUpdate()
      produto.card_ativo = !produto.card_ativo;
    },
    
    diminuirValorExp(produto){
      produto.quantidade_entrega_ato_exp--;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_entrega_ato_exp < 0){
        produto.quantidade_entrega_ato_exp = 0;
      }
      
      this.arrumarGrid(produto, true);
    },
    
    aumentarValorExp(produto){
      produto.quantidade_entrega_ato_exp++;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_entrega_ato_exp < 0){
        produto.quantidade_entrega_ato_exp = 0;
      }
     
      this.arrumarGrid(produto, true);
    },
    
    aumentarValor(produto){
      produto.quantidade_entrega_ato++;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_entrega_ato < 0){
        produto.quantidade_entrega_ato = 0;
      }

      if(produto.quantidade_entrega_ato > produto.quantidade_venda){
        produto.quantidade_entrega_ato = produto.quantidade_venda;
      }
     
      this.arrumarGrid(produto, true);
    },
    
    aumentarValorAgendar(produto){
      produto.quantidade_agendar++;
      produto.quantidade_agendar > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_agendar < 0){
        produto.quantidade_agendar = 0;
      }
      
      if(produto.quantidade_agendar > produto.quantidade_venda){
        produto.quantidade_agendar = produto.quantidade_venda;
      }
      
      this.arrumarGrid(produto, true);
    },
    
    aumentarValorPed(produto){
      produto.quantidade_pedida++;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_pedida < 0){
        produto.quantidade_pedida = 0;
      }
      
      this.arrumarGrid(produto, true);
    },
    
    aumentarValorDep(produto){
      produto.quantidade_entrega_ato_dep++;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_entrega_ato_dep < 0){
        produto.quantidade_entrega_ato_dep = 0;
      }
     
      this.arrumarGrid(produto, true);
    },
    
    diminuirValor(produto){
      produto.quantidade_entrega_ato--;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_entrega_ato < 0){
        produto.quantidade_entrega_ato = 0;
      }

      if( produto.quantidade_entrega_ato == 0 && this.tipo_entrega === 'RLR'){
        produto.tipo_retirar_lojas_rede = 'S';
      }
     
      this.arrumarGrid(produto, true);
    },
    
    diminuirValorAgendar(produto){
      produto.quantidade_agendar--;
      produto.quantidade_agendar > 0 ? produto.selecionado = true : produto.selecionado = false;

      if(produto.quantidade_agendar< 0){
        produto.quantidade_agendar = 0;
      }
     
      this.arrumarGrid(produto, true);
    },
    
    diminuirValorPed(produto){
      produto.quantidade_pedida--;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;
      
      if(produto.quantidade_pedida < 0){
        produto.quantidade_pedida = 0;
      }
      
      this.arrumarGrid(produto, true);
    },
    
    diminuirValorDep(produto){
      produto.quantidade_entrega_ato_dep--;
      produto.quantidade_entrega_ato > 0 ? produto.selecionado = true : produto.selecionado = false;

      if(produto.quantidade_entrega_ato_dep < 0){
        produto.quantidade_entrega_ato_dep = 0;
      }
      
      this.arrumarGrid(produto, true);
    },
    
    marcarTodosAgendar(){
      for (let i in this.produtos_entrega_no_ato) {

        if(this.produtos_entrega_no_ato[i].quantidade_venda > 0){
          this.produtos_entrega_no_ato[i].quantidade_agendar = this.produtos_entrega_no_ato[i].quantidade_venda;
        }

        if(this.produtos_entrega_no_ato[i].quantidade_sem_agendamento > 0){
          this.produtos_entrega_no_ato[i].quantidade_agendar = this.produtos_entrega_no_ato[i].quantidade_sem_agendamento;
        }

        if(this.tipo_entrega === 'RLR'){
          this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede = 'S';
        } else{
          this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede = 'N';
        }

        this.produtos_entrega_no_ato[i].quantidade_entrega_ato = 0;
        this.produtos_entrega_no_ato[i].quantidade_entrega_ato_dep = 0;
        this.produtos_entrega_no_ato[i].quantidade_entrega_ato_exp = 0;
        this.produtos_entrega_no_ato[i].quantidade_sem_agendamento = 0
  
        this.arrumarGrid(this.produtos_entrega_no_ato[i], (i == this.produtos_entrega_no_ato.length - 1));
      }
      
      Biblioteca.informar("Todos os produtos foram agendados para entrega.");
    },

    marcarTodosSemPrevisao(){
      for (let i in this.produtos_entrega_no_ato) {
        if(this.produtos_entrega_no_ato[i].quantidade_venda > 0){
          this.produtos_entrega_no_ato[i].quantidade_sem_agendamento = this.produtos_entrega_no_ato[i].quantidade_venda;
        }

        if(this.produtos_entrega_no_ato[i].quantidade_agendar > 0){
          this.produtos_entrega_no_ato[i].quantidade_sem_agendamento = this.produtos_entrega_no_ato[i].quantidade_agendar
        }

        this.produtos_entrega_no_ato[i].quantidade_entrega_ato = 0;
        this.produtos_entrega_no_ato[i].quantidade_entrega_ato_dep = 0;
        this.produtos_entrega_no_ato[i].quantidade_entrega_ato_exp = 0;
        this.produtos_entrega_no_ato[i].quantidade_agendar = 0;
      
        this.arrumarGrid(this.produtos_entrega_no_ato[i], (i == this.produtos_entrega_no_ato.length - 1));
      }
      
      Biblioteca.informar("Todos os produtos estão sem agendamento.");
    },

    desmarcarTodosEntregarAgora(){
      for (let i in this.produtos_entrega_no_ato) {
        this.produtos_entrega_no_ato[i].quantidade_entrega_ato = 0;
        this.produtos_entrega_no_ato[i].quantidade_agendar = this.produtos_entrega_no_ato[i].quantidade_venda;
        
        if(this.tipo_entrega === 'RLR'){
          this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede = 'S';
        } else{
          this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede = 'N';
        }
        
        this.produtos_entrega_no_ato[i].selecionado =  false;
        this.arrumarGrid(this.produtos_entrega_no_ato[i], (i == this.produtos_entrega_no_ato.length - 1));
      }
      
      Biblioteca.informar("Todos os produtos foram agendados para entrega.");
      this.todos_marcados =  false;
    },

    marcarTodosEntregarAgora(){
      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        this.produtos_entrega_no_ato[i].quantidade_entrega_ato = this.produtos_entrega_no_ato[i].quantidade_venda;
        this.produtos_entrega_no_ato[i].quantidade_agendar = 0;
        this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede = 'N';
        this.produtos_entrega_no_ato[i].selecionado =  true;
        
        this.arrumarGrid(this.produtos_entrega_no_ato[i], (i == this.produtos_entrega_no_ato.length - 1));
      }

      Biblioteca.informar("Todos os produtos serão entregues no ato.");
      this.todos_marcados =  true;
    },
    
    marcarTodosRetiraRede(){
      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        this.produtos_entrega_no_ato[i].quantidade_agendar = this.produtos_entrega_no_ato[i].quantidade_venda;
        this.produtos_entrega_no_ato[i].quantidade_entrega_ato = 0;
        this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede = 'S';
        this.produtos_entrega_no_ato[i].selecionado =  true;
        
        this.arrumarGrid(this.produtos_entrega_no_ato[i], (i == this.produtos_entrega_no_ato.length - 1));
      }

      Biblioteca.informar("Todos os produtos foram agendados para retirar lojas rede.");
      this.todos_marcados =  true;
    },

    calcularFreteTiposVeiculos(){
      for (let i = 0; i < this.frete_tipos_veiculos_buscar_entregas_ato.length; i++) {
        this.frete_tipos_veiculos_buscar_entregas_ato[i].valor_total = (this.frete_tipos_veiculos_buscar_entregas_ato[i].viagens * this.frete_tipos_veiculos_buscar_entregas_ato[i].valor_frete);
      }
    },

    async buscarDataMinimaEntrega(){
      try {
        let tipo_data_entrega = this.tipo_agendamento_entrega == 'P' ? 'calcular_data_entrega' : 'calcular_data_minima_entrega'
        let bairro_id = 0
      
        if (this.bairro_entrega_id){
          bairro_id = this.bairro_entrega_id;
        }
        
        if (this.tipo_agendamento_entrega != 'E'){
          this.data_entrega = '';
          this.hora_entrega = '';
        }

        if (!this.temQuantidadeAgendar) {
          return;
        }

        let parametros = {
          tipo_data_entrega: tipo_data_entrega,
          data_minima_entrega: this.data_minima_entrega,
          tipo_agendamento_entrega: this.tipo_agendamento_entrega,
          bairro_id: bairro_id
        }

        let retorno = await REntrega.buscarDataEntrega(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }
        
        if (this.tipo_agendamento_entrega == 'P'){
          this.data_entrega = retorno.dados.data_entrega;
        }
      
        if (this.tipo_agendamento_entrega == 'E'){
          this.data_minima_entrega = '';
          this.data_entrega = retorno.dados.data_entrega ? retorno.dados.data_entrega : this.data_entrega;
          this.hora_entrega = '';
        }

        if (this.tipo_agendamento_entrega == 'R'){
          this.data_minima_entrega = '';
          this.data_entrega = retorno.dados.data_entrega;
          this.hora_entrega = '';
        }
      } catch (error) {
        this.verificarErro(error, 'buscarDataMinimaEntrega'); 
      }
    },

    verificarErro(erro, nome_funcao){
      this.processando = false;
      Biblioteca.gerarLogNomeFuncao('BuscarEntregasNoAto.vue -> ' + nome_funcao);
      let mensagem = Biblioteca.tratamentoMensagem(erro);
      Biblioteca.exclamar(mensagem);
    },

    async definirLotesProdutoSelecionado(){
      if 
        (
          this.formatarValor(
            this.totalizador_divisoes_produto_selecionado.quantidade_utilizar_ato + 
            this.totalizador_divisoes_produto_selecionado.quantidade_agendar, 2
          ) != 
          this.formatarValor(
            this.produto_selecionado_editando.quantidade_entrega_ato + 
            this.produto_selecionado_editando.quantidade_agendar, 2
          )
        ){
          swal(
            {
              title: "Definições de lotes do produto",
              text: 'A quantidade selecionada para os lotes do produto é diferente da quantidade selecionada para o produto!',
              icon: "error",
              button: {
                confirm: {
                text: "OK",
                value: true,
                visible: true,
                closeModal: true,
                },
              },
            }
          );

        return;
      }

      let empresa = undefined;
      let multiplo_venda = undefined;
      let contem_multiplo_errado = false;
      let quantidade_utilizada = undefined;

      for (let i = 0; i < this.divisoes_lotes_produto_selecionado.length; i++) {
        this.divisoes_lotes_produto_selecionado[i].produto_id = Biblioteca.valorInt(this.divisoes_lotes_produto_selecionado[i].produto_id);

        if 
          (
            this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato + 
            this.divisoes_lotes_produto_selecionado[i].quantidade_agendar > 
            Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].estoque_disponivel)
          )
        {
          swal(
            {
              title: "Definições de lotes do produto",
              text: 'Estoque insuficiente para a divisão selecionada! Lote ' + this.divisoes_lotes_produto_selecionado[i].local_id + ' - ' + this.divisoes_lotes_produto_selecionado[i].nome_local,
              icon: "error",
              button: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  closeModal: true,
                },
              },
            }
          );

          return;
        }

        if
          (
            (Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato) > 0) &&
            (
              Math.round(Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato) / Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].multiplo_venda)) !=
              Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato) / Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].multiplo_venda)
            )
          )
        {
          quantidade_utilizada = this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato;
          multiplo_venda = this.divisoes_lotes_produto_selecionado[i].multiplo_venda; 
          empresa = this.divisoes_lotes_produto_selecionado[i].nome_empresa;
          contem_multiplo_errado = true;
          break;
        }

        if
          (
            (Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_agendar) > 0) &&
            (
              Math.round(Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_agendar) / Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].multiplo_venda)) !=
              Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].quantidade_agendar) / Biblioteca.valor(this.divisoes_lotes_produto_selecionado[i].multiplo_venda)
            )
          )
        {
          quantidade_utilizada = this.divisoes_lotes_produto_selecionado[i].quantidade_agendar;
          multiplo_venda = this.divisoes_lotes_produto_selecionado[i].multiplo_venda;
          empresa = this.divisoes_lotes_produto_selecionado[i].nome_empresa;
          contem_multiplo_errado = true;
          break;
        }
      }

      if (contem_multiplo_errado){
        swal(
          {
            title: "Definições de lotes do produto",
            text: 'A quantidade informada (' + this.formatarValor(quantidade_utilizada, 3) + ') do produto ' + this.formatarValor(this.produto_selecionado_editando.produto_id, 0) + ' - ' + this.produto_selecionado_editando.nome + ' ' +
            'não se adequa ao seu múltiplo de venda (' + multiplo_venda + ') - ' + empresa + '!',
            icon: "error",
            button: {
              confirm: {
              text: "OK",
              value: true,
              visible: true,
              closeModal: true,
              },
            },
          }
        );

        return;
      }

      let definicoes = Object.assign([], this.divisoes_lotes_produto_selecionado);
      for (let i = 0; i < definicoes.length; i++) {
        definicoes[i].quantidade_ent_ato = definicoes[i].quantidade_utilizar_ato;
      }

      try {
        let parametros = {
          definicoes_lotes: definicoes
        }

        let retorno = await ROrcamentoBuscarEntregasNoAto.buscarEntregasNoAtoVerificarDadosLotes(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        let i = 0;
        let tinha_lote_anterior = false;
        while (true) {
          if (i >= this.definicoes_lotes_buscar_entregas_ato.length){
            break;
          }

          if (Biblioteca.valorInt(this.definicoes_lotes_buscar_entregas_ato[i].produto_id) == Biblioteca.valorInt(this.produto_selecionado_editando.produto_id)){
            this.definicoes_lotes_buscar_entregas_ato.splice(i, 1); // Removendo do array as definições do produto selecionado
            tinha_lote_anterior = true;
          } else{
            i++;
          }
        }

        for (let i = 0; i < this.divisoes_lotes_produto_selecionado.length; i++) {
          if (this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato > 0 || this.divisoes_lotes_produto_selecionado[i].quantidade_agendar > 0){
            this.divisoes_lotes_produto_selecionado[i].ponta_estoque = this.produto_selecionado_editando.ponta_estoque;
            this.definicoes_lotes_buscar_entregas_ato.push(Object.assign({}, this.divisoes_lotes_produto_selecionado[i]));
          }
        }

        for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
          if (this.produto_selecionado_editando.produto_id == this.produtos_entrega_no_ato[i].produto_id){
            this.produtos_entrega_no_ato[i].definir_lote = 'Sim';
          
            if (tinha_lote_anterior){
              this.produtos_entrega_no_ato[i].definiu_lote_manualmente = 'S'
            }

            break;
          }
        }
      
        this.abrirModalDefinirLoteProduto = false;
      } catch (e) {
        swal({
          title: "Definições de lotes do produto",
          text: e.message,
          icon: "error",
          button: {
            confirm: {
            text: "OK",
            value: true,
            visible: true,
            closeModal: true,
            },
          },
        });
      }
    },
    
    validarDefinicaoLoteProduto: function(produto_id, quantidade){
      for (let i = 0; i < this.definicoes_lotes_buscar_entregas_ato.length; i++) {
        if (this.definicoes_lotes_buscar_entregas_ato[i].produto_id == produto_id){
          return true;
        }
      }
  
      return false;
    },
    
    lotesDefinidosProduto: function(produto_id) {
      let lotes = [];
  
      for (let i = 0; i < this.definicoes_lotes_buscar_entregas_ato.length; i++) {
        if (this.definicoes_lotes_buscar_entregas_ato[i].produto_id == produto_id)
        lotes.push(this.definicoes_lotes_buscar_entregas_ato[i].lote);
      }
      
      return lotes;
    },
    
    existeProdutoControleLoteSemLote: function(){
      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        if 
          (
            !this.validarDefinicaoLoteProduto(this.produtos_entrega_no_ato[i].produto_id, this.produtos_entrega_no_ato[i].quantidade) &&
            (
              (this.produtos_entrega_no_ato[i].tipo_controle_estoque == 'L') || 
              (this.produtos_entrega_no_ato[i].tipo_controle_estoque == 'P') || 
              (this.produtos_entrega_no_ato[i].tipo_controle_estoque == 'T') || 
              (this.produtos_entrega_no_ato[i].tipo_controle_estoque == 'G')
            )
          )
        {
          return true;
        }
      }
  
      return false;
    },

    todosProdutosRetirarLojasRede: function(){
      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        if (!this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede || this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede == 'N'){
          return false;
        }
      }
  
      return true;
    },
    
    gravar(){
      let prod_sem_qtd_agendar_ret_loj_rede = 0;
  
      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        if (this.produtos_entrega_no_ato[i].quantidade_sem_agendamento < 0){
          Biblioteca.exclamar('A quantidade sem agendamento deve ser maior ou igual a zero!');
          return;
        }

        if 
          (
            this.tipo_entrega == 'ESA' && 
            (this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede && this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede != 'N' ) && 
            !(this.produtos_entrega_no_ato[i].quantidade_agendar > 0)
          )
        {
          prod_sem_qtd_agendar_ret_loj_rede ++;
        }

        this.qtd_pendente += this.produtos_entrega_no_ato[i].quantidade_agendar;
        this.qtd_sem_agendamento += this.produtos_entrega_no_ato[i].quantidade_sem_agendamento;
      }

      if (this.existeProdutoControleLoteSemLote() && this.tipo_entrega != 'ESA'){
        swal({
          title: "Validação de produtos",
          text: 'É necessário definir os lotes de todos os produtos que controlam lote!',
          icon: "error",
          button: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              closeModal: true, 
            },
          },
        });
  
        return;
      }

      if (this.todosProdutosRetirarLojasRede() && this.tipo_entrega != 'RLR'){
        swal({
          title: "Validação de tipo de entrega",
          text: 'É necessário redefinir o tipo de entrega do pedido para "Retirar lojas rede"!',
          icon: "error",
          button: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              closeModal: true,
            },
          },
        });
  
        return;
      }

      if (this.qtd_pendente == 0 && this.qtd_sem_agendamento == 0 && this.valorTotalFretesTerceirizados > 0) {
        swal('Não existem itens para entregar e por este motivo o frete de veículos será desconsiderado! Deseja continuar?', {
          buttons: {
            ok: 'Ok',
            cancel: "Cancelar",
          },
        }).then((value) => {
          switch (value) {
            case "ok":
            this.finalizarBuscarEntregaNoAto();
            break;  
            default:
            swal("Procedimento cancelado pelo usuário!");
          }
        });
  
        return;
      }

      if (prod_sem_qtd_agendar_ret_loj_rede > 0) {
        swal('Existem produtos definidos para "Retirar lojas rede" sem quantidade à agendar informada! Deseja continuar?', {
          buttons: {
            ok: 'Ok',
            cancel: "Cancelar",
          },
        })
        .then((value) => {
          switch (value) {
            case "ok":
            this.finalizarBuscarEntregaNoAto();
            break;  
            default:
            swal("Procedimento cancelado pelo usuário!");
          }
        });
  
        return;
      }
    
      this.finalizarBuscarEntregaNoAto();
    },
    
    async finalizarBuscarEntregaNoAto(){
      try {
        this.processando = true;
      
        let definicoes = Object.assign([], this.definicoes_lotes_buscar_entregas_ato);
        for (let i = 0; i < definicoes.length; i++) {
          definicoes[i].quantidade_ent_ato = definicoes[i].quantidade_utilizar_ato;
        }

        let usuario_redefiniu_lote = false;
        for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
          if (this.produtos_entrega_no_ato[i].definiu_lote_manualmente == 'S'){
            usuario_redefiniu_lote = true;
            break;
          }
        }

        let parametros = {
          itens_entrega_ato: this.produtos_entrega_no_ato,
          tipo_entrega: this.tipo_entrega,
          definicoes_lotes: definicoes,
          cliente_id: parseInt(strPadraoToNumber(this.cliente.cadastro_id)),
          condicao_id: parseInt(strPadraoToNumber(this.condicao_pagamento.condicao_id)),
          recebimento_entrega: this.recebimento_na_entrega ? 'S' : 'N',
          tipo_agendamento_entrega: this.tipo_agendamento_entrega,
          data_minima_entrega_partir: moment(this.data_minima_entrega, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          tipos_veiculos: this.frete_tipos_veiculos_buscar_entregas_ato,
          data_entrega: moment(this.data_entrega, 'YYYY-MM-DD').format('DD/MM/YYYY')
        }

        let retorno = await ROrcamentoBuscarEntregasNoAto.enviarDadosEntregasNoAto(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        let dados_entrega = retorno.dados;

        // Convertanto campos para valor numérico
        for (let i in dados_entrega.itens_entrega_ato) {
          dados_entrega.itens_entrega_ato[i].item_id = Biblioteca.valorInt(dados_entrega.itens_entrega_ato[i].item_id);
          dados_entrega.itens_entrega_ato[i].produto_id = Biblioteca.valorInt(dados_entrega.itens_entrega_ato[i].produto_id);
          dados_entrega.itens_entrega_ato[i].qtd_entrega_ato = Biblioteca.valor(dados_entrega.itens_entrega_ato[i].qtd_entrega_ato);
          dados_entrega.itens_entrega_ato[i].qtd_entrega_ato_dep = Biblioteca.valor(dados_entrega.itens_entrega_ato[i].qtd_entrega_ato_dep);
          dados_entrega.itens_entrega_ato[i].qtd_entrega_ato_exp = Biblioteca.valor(dados_entrega.itens_entrega_ato[i].qtd_entrega_ato_exp);
          dados_entrega.itens_entrega_ato[i].qtd_agendar = Biblioteca.valor(dados_entrega.itens_entrega_ato[i].qtd_agendar);
          dados_entrega.itens_entrega_ato[i].empresa_retirar_lojas_rede_id = Biblioteca.valorInt(dados_entrega.itens_entrega_ato[i].empresa_retirar_lojas_rede_id);
          dados_entrega.itens_entrega_ato[i].qtd_sem_previsao = Biblioteca.valor(dados_entrega.itens_entrega_ato[i].qtd_sem_previsao); 
        }

        // Convertanto campos para valor numérico
        for (let i in dados_entrega.itens_lote) {
          dados_entrega.itens_lote[i].empresa_id = Biblioteca.valorInt(dados_entrega.itens_lote[i].empresa_id);
          dados_entrega.itens_lote[i].orcamento_id = Biblioteca.valorInt(dados_entrega.itens_lote[i].orcamento_id);
          dados_entrega.itens_lote[i].item_id = Biblioteca.valorInt(dados_entrega.itens_lote[i].item_id);
          dados_entrega.itens_lote[i].produto_id = Biblioteca.valorInt(dados_entrega.itens_lote[i].produto_id);
          dados_entrega.itens_lote[i].quantidade_ent_ato = Biblioteca.valor(dados_entrega.itens_lote[i].quantidade_ent_ato);
          dados_entrega.itens_lote[i].quantidade_agendar = Biblioteca.valor(dados_entrega.itens_lote[i].quantidade_agendar);
        }

        dados_entrega.recebimento_na_entrega = this.recebimento_na_entrega;
        dados_entrega.tipo_contato_cliente = this.tipo_contato_cliente;
        dados_entrega.definicoes_lotes = dados_entrega.itens_lote;
        dados_entrega.usuario_redefiniu_lote = usuario_redefiniu_lote;
        dados_entrega.frete_rota = this.frete_rota_buscar_entregas_ato;
        dados_entrega.frete_adicional_andar_escada = this.frete_adicional_andar_buscar_entregas_ato;
        dados_entrega.tipo_agendamento_entrega = this.tipo_agendamento_entrega;
        dados_entrega.frete_tipos_veiculos = (this.qtd_pendente == 0 && this.qtd_sem_agendamento == 0 && this.valorTotalFretesTerceirizados > 0) ? [] : this.frete_tipos_veiculos_buscar_entregas_ato;
        
        if (this.tipo_entrega == 'ESA' && this.temQuantidadeAgendar){
          dados_entrega.data_entrega = this.data_entrega;
          dados_entrega.hora_entrega = this.hora_entrega;

          if (dados_entrega.tipo_agendamento_entrega == 'P'){
            dados_entrega.data_minima_entrega = this.data_minima_entrega;
          } else{
            dados_entrega.data_entrega = '';
            dados_entrega.hora_entrega = '';
          }
        }

        dados_entrega.peso_total_entrega = this.total_peso;
        
        this.processando = false;
        this.$emit('confirmar_buscar_entregas_no_ato', dados_entrega);
        this.visivel = false;
      } catch (error) {
        this.verificarErro(error, 'finalizarBuscarEntregaNoAto');
      }
    },
    
    verificarErro(erro, nome_funcao){
      this.processando = false;
      Biblioteca.gerarLogNomeFuncao('BuscarEntregasNoAto.vue -> ' + nome_funcao);
      let mensagem = Biblioteca.tratamentoMensagem(erro);
      Biblioteca.exclamar(mensagem);
    },
    
    ajustarValorTotalFrete(){
      let recalculo_frete_andar = 0;
      let valor_frete_andar = 0;
      let qtd_retirar_lojas_rede = 0;
      let qtd_sem_agendamento = 0;
      let qtd_entrega_ato = 0;
      let qtd_pendente = 0;
  
      for (let i in this.produtos_entrega_no_ato) {
        qtd_pendente += this.produtos_entrega_no_ato[i].quantidade_agendar;
        qtd_sem_agendamento += this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede == 'N' ? this.produtos_entrega_no_ato[i].quantidade_sem_agendamento : 0;
        qtd_entrega_ato += this.produtos_entrega_no_ato[i].quantidade_entrega_ato + this.produtos_entrega_no_ato[i].quantidade_entrega_ato_dep + this.produtos_entrega_no_ato[i].quantidade_entrega_ato_exp;
  
        if (this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede != 'N') {
          qtd_retirar_lojas_rede++; 
        }
  
        if 
        (
          (
            this.produtos_entrega_no_ato[i].quantidade_agendar > 0 ||
            this.produtos_entrega_no_ato[i].quantidade_sem_agendamento > 0
          ) && this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede == 'N'
        )
        {
          recalculo_frete_andar += 
            (
              this.produtos_entrega_no_ato[i].peso *
              this.valor_frete_andar_elevador_escada *
              (this.produtos_entrega_no_ato[i].quantidade_agendar <= 0 || this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede != 'N' ? 0 : this.produtos_entrega_no_ato[i].quantidade_agendar) +
              (this.produtos_entrega_no_ato[i].quantidade_sem_agendamento <= 0 || this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede != 'N' ? 0 : this.produtos_entrega_no_ato[i].quantidade_sem_agendamento)
            );
        }
      } 

      if 
        (
          qtd_pendente == 0 &&
          qtd_sem_agendamento == 0 *
          (
            (
              (
                // Quando todos os itens forem marcados para retirar lojas rede
                // Quando todos os itens forem marcados para entrega no ato
                // Quando metade dos itens forem marcados para entrega no ato e metade para retirar lojas rede
                (qtd_retirar_lojas_rede > 0) ||
                (qtd_entrega_ato > 0)
              )
            ) ||
            (
              // Quando todos os itens forem marcados para entrega no ato
              (qtd_retirar_lojas_rede == 0) &&
              (qtd_entrega_ato > 0)
            )
          )
        )
      {
        this.valor_frete_buscar_entregas_ato = 0;
        this.frete_adicional_andar_buscar_entregas_ato = 0;
        return;
      }

      if
        (
          (this.valor_anterior_frete_adicional_andar_buscar_entregas_ato > 0) &&
          (qtd_pendente > 0 || qtd_sem_agendamento > 0) &&
          (qtd_retirar_lojas_rede > 0 || qtd_entrega_ato > 0)
        )
      {
        this.frete_adicional_andar_buscar_entregas_ato = recalculo_frete_andar;
        this.valor_frete_buscar_entregas_ato = this.frete_adicional_andar_buscar_entregas_ato + this.valorTotalFretesTerceirizados;
        return;
      }

      this.frete_adicional_andar_buscar_entregas_ato = this.valor_anterior_frete_adicional_andar_buscar_entregas_ato;
      this.valor_frete_buscar_entregas_ato = this.frete_adicional_andar_buscar_entregas_ato + this.valorTotalFretesTerceirizados;
      this.total_fretes = this.valor_frete_buscar_entregas_ato;
    },
    
    configurarRetirarLojasRedeProduto(produto){
      produto.nome_empresa_ret_lojas_rede = '';
      produto.empresa_retirar_lojas_rede_id = '';
      this.arrumarGrid(produto, true);
    },
    
    cancelarBuscarEntregasNoAto() {
      this.visivel = false;
    },
    
    verificarModalAberto(){        
      const el = document.documentElement
      if (this.verificarModal) {
        el.classList.add('modal-aberto');
      } else {
        el.classList.remove('modal-aberto');
      } 
    },

    async definirLoteEntregaAto(produto) {
      try {
        if (Object.entries(produto).length === 0) {
          Biblioteca.exclamar('Necessário selecionar um produto primeiro!');
          return;
        }

        if (produto.tipo_controle_estoque != 'L' && produto.tipo_controle_estoque != 'P' && produto.tipo_controle_estoque != 'T' && produto.tipo_controle_estoque != 'G') {
          Biblioteca.exclamar('Este produto não controla lote!');
          return;
        }

        if (produto.tipo_controle_estoque == 'L' ||  produto.tipo_controle_estoque == 'P'|| produto.tipo_controle_estoque == 'T'|| produto.tipo_controle_estoque == 'G') {
          if (Object.entries(produto).length) {
            this.divisoes_lotes_produto_selecionado = [];
            this.produto_selecionado_editando = Object.assign({}, produto);

            let parametros = {
              produto_id: produto.produto_id,
              tipo_selecao_automatica_lote: produto.tipo_selecao_automatica_lote,
              ponta_estoque: produto.ponta_estoque,
              tipo_entrega: this.tipo_entrega,
              bairro_id: this.bairro_entrega_id,
              empresa_retirar_lojas_rede_id: produto.empresa_retirar_lojas_rede_id
            }

            let retorno = await REstoqueBuscarDivisaoEstoque.buscarDivisaoEstoque(this.axios, parametros);

            if (retorno.houve_erro == 'S'){
              Biblioteca.exclamar(retorno.mensagem);
              return;
            }
          
            for (let i = 0; i < retorno.dados.length; i++) {
              retorno.dados[i].quantidade_utilizar_ato = 0;
              retorno.dados[i].quantidade_agendar = 0;
              retorno.dados[i].definicao_automatica = false;
            }

            this.divisoes_lotes_produto_selecionado = retorno.dados.slice(0);
            this.abrirModalDefinirLoteProduto = true;
          }
        }
      } catch (error) {
        this.verificarErro(error, 'definirLoteEntregaAto');  
      }
    },
    
    configurarRetirarLojasRedeProdutosSelecionados: function(){
      if (this.novo_tipo_retirar_lojas_rede == ''){
        Biblioteca.exclamar('É necessário selecionar o tipo de retirar lojas rede!');
        return;
      }
    
      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        if (this.produtos_entrega_no_ato[i].selecionado) {
          this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede = this.novo_tipo_retirar_lojas_rede;
          this.produtos_entrega_no_ato[i].empresa_retirar_lojas_rede_id = this.nova_empresa_retirar_lojas_rede_id;
          this.produtos_entrega_no_ato[i].selecionado = false;
          
          this.arrumarGrid(this.produtos_entrega_no_ato[i], (i == this.produtos_entrega_no_ato.length - 1));
        }
      } 

      this.abrirModalTipoRetirarLojasRede = false;
      this.nova_empresa_retirar_lojas_rede_id = '';
      this.novo_tipo_retirar_lojas_rede = '';
      this.$forceUpdate(); 
    },
    
    verificarAbrirModalTipoRetirarLojasRede: function(){
      let tem_selecionado = false;

      for(let k in this.produtos_entrega_no_ato){
        this.produtos_entrega_no_ato[k].selecionado = true;
      }

      this.marcarTodosRetiraRede();
      this.abrirModalTipoRetirarLojasRede = true;
    },
    
    cancelarSelecaoTipoRetirarLojasRede: function(){
      this.abrirModalTipoRetirarLojasRede = false;
      this.novo_tipo_retirar_lojas_rede = '';
      this.nova_empresa_retirar_lojas_rede_id = '';
    },
    
    totalizarDivisoesProdutoSelecionado: function(){
      let valor_total_ato = 0;
      let valor_total_agendar = 0;
  
      for (let i = 0; i < this.divisoes_lotes_produto_selecionado.length; i++) {
        valor_total_ato += this.divisoes_lotes_produto_selecionado[i].quantidade_utilizar_ato;
        valor_total_agendar += this.divisoes_lotes_produto_selecionado[i].quantidade_agendar;
      }

      this.totalizador_divisoes_produto_selecionado.quantidade_utilizar_ato = valor_total_ato;
      this.totalizador_divisoes_produto_selecionado.quantidade_agendar = valor_total_agendar;
    },
    
    async buscarDivisoesAutomaticasLote(produto){
      try {

        if (produto.definiu_lote_manualmente == 'S') {
          return;
        }

        let parametros = {
          item_id: produto.item_id,
          produto_id: produto.produto_id,
          quantidade_entrega_agendar: this.formatarValor(produto.quantidade_agendar),
          quantidade_entrega_ato: this.formatarValor(produto.quantidade_entrega_ato + produto.quantidade_entrega_ato_dep + produto.quantidade_entrega_ato_exp),
          quantidade_entrega_sem_agendamento: this.formatarValor(produto.quantidade_sem_agendamento),
          tipo_selecao_automatica_lote: produto.tipo_selecao_automatica_lote,
          ponta_estoque: produto.ponta_estoque,
          tipo_entrega: this.tipo_entrega,
          bairro_id: this.bairro_entrega_id,
          tipo_retirar_lojas_rede: produto.tipo_retirar_lojas_rede,
          empresa_retirar_lojas_rede_id: produto.empresa_retirar_lojas_rede_id
        }

        let retorno = await REstoqueBuscarDivisaoEstoqueAutomatico.buscarDivisaoEstoqueAutomatico(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }
  
        if (this.definicoes_lotes_buscar_entregas_ato){
          let i = 0;
          while (true) {
            if (i >= this.definicoes_lotes_buscar_entregas_ato.length)
              break;
    
            if (this.definicoes_lotes_buscar_entregas_ato[i].definicao_automatica && (this.definicoes_lotes_buscar_entregas_ato[i].produto_id == produto.produto_id)){
              this.definicoes_lotes_buscar_entregas_ato.splice(i, 1); // Removendo do array as definições do produto selecionado
            }
            else{
              i++;
            }
          }
        }

        if (retorno.dados.length == 0) {
          return;
        }

        for (let j = 0; j < retorno.dados.length; j++) {
          retorno.dados[j].definicao_automatica = true;
          retorno.dados[j].quantidade_utilizar_ato = retorno.dados[j].quantidade_utilizar_ato != undefined ? Biblioteca.valor(retorno.dados[j].quantidade_utilizar_ato) : 0;
          retorno.dados[j].quantidade_agendar = retorno.dados[j].quantidade_agendar != undefined ? Biblioteca.valor(retorno.dados[j].quantidade_agendar) : 0;

          let utilizar_lote = true;
          for (let i = 0; i < this.definicoes_lotes_buscar_entregas_ato.length; i++) {
            if (retorno.dados[j].produto_id == this.definicoes_lotes_buscar_entregas_ato[i].produto_id){
              utilizar_lote = this.definicoes_lotes_buscar_entregas_ato[i].definicao_automatica; 
              break;
            }
          }
          
          if (utilizar_lote){
            this.definicoes_lotes_buscar_entregas_ato.push(Object.assign({}, retorno.dados[j])); 
          }
        }
      
        produto.definir_lote = 'Sim';
      } catch (error) {
        this.verificarErro(error, 'buscarDivisoesAutomaticasLote');
      }
    },

    async arrumarGrid(produto, verificacaoFinal) {
      let total = produto.quantidade_entrega_ato + produto.quantidade_agendar;
      total > produto.quantidade_venda ? this.valor_invalido = true: this.valor_invalido = false;
      
      if(this.tipo_entrega === 'RLR' && produto.tipo_retirar_lojas_rede === 'N' && produto.quantidade_entrega_ato == 0){
        produto.tipo_retirar_lojas_rede = 'S';
        produto.quantidade_agendar = produto.quantidade_venda;
      }
      
      if(produto.quantidade_entrega_ato >= produto.quantidade_venda){
        produto.tipo_retirar_lojas_rede = 'N';
      }

      if(produto.quantidade_sem_agendamento >= produto.quantidade_venda){
        produto.tipo_retirar_lojas_rede = 'N';
        produto.quantidade_sem_agendamento = produto.quantidade_venda;
      }

      if(produto.quantidade_entrega_ato_dep >= produto.quantidade_venda){
        produto.tipo_retirar_lojas_rede = 'N';
        produto.quantidade_entrega_ato_dep = produto.quantidade_venda;
      }

      if(produto.quantidade_entrega_ato_exp >= produto.quantidade_venda){
        produto.tipo_retirar_lojas_rede = 'N';
        produto.quantidade_entrega_ato_exp = produto.quantidade_venda;
      }
     
      if (this.tipo_entrega == 'ESA'){
        produto.quantidade_sem_agendamento =
        produto.quantidade_venda -
        produto.quantidade_entrega_ato -
        produto.quantidade_entrega_ato_dep -
        produto.quantidade_entrega_ato_exp -
        produto.quantidade_agendar;
      
        if (produto.quantidade_sem_agendamento == 0){
          produto.data_prevista_entrega = 0;
  
          if (produto.quantidade_agendar == 0){
            produto.tipo_retirar_lojas_rede = 'N';
            produto.nome_empresa_ret_lojas_rede = '';
            produto.empresa_retirar_lojas_rede_id = '';
          }
        }
      } else {
        produto.quantidade_agendar =
        produto.quantidade_venda -
        produto.quantidade_entrega_ato -
        produto.quantidade_entrega_ato_dep -
        produto.quantidade_entrega_ato_exp;
      }

      if (this.tipo_entrega == 'RLR' && produto.quantidade_sem_agendamento > 0 && produto.tipo_retirar_lojas_rede == '') {
        produto.tipo_retirar_lojas_rede = 'S';
      }

      // && (this.tipo_entrega == 'ATO' || this.tipo_entrega == 'EPG')
      if ((produto.tipo_controle_estoque == 'L' || produto.tipo_controle_estoque == 'P' || produto.tipo_controle_estoque == 'T')) {
        await this.buscarDivisoesAutomaticasLote(produto);
      }

      if (verificacaoFinal) {
        await this.buscarDataMinimaEntrega();
        await this.calcularTotalFreteRota();
        await this.ajustarValorTotalFrete();
      }
    },

    calcularTotalFreteRota(){
      this.total_peso = 0;
      this.tot_valor_entregar = 0;

      for (let i = 0; i < this.produtos_entrega_no_ato.length; i++) {
        this.qtd_agendar = this.produtos_entrega_no_ato[i].quantidade_agendar;
        this.qtd_sem_agendamento = this.produtos_entrega_no_ato[i].quantidade_sem_agendamento;

        if (this.produtos_entrega_no_ato[i].tipo_retirar_lojas_rede == 'N') {
          this.tot_valor_entregar += this.produtos_entrega_no_ato[i].preco_venda * (this.qtd_agendar + this.qtd_sem_agendamento);
          this.total_peso += (this.qtd_agendar * this.produtos_entrega_no_ato[i].peso + (this.qtd_sem_agendamento * this.produtos_entrega_no_ato[i].peso));
        }
      }

      if (this.tipo_entrega == 'EPG' || this.tipo_entrega == 'ESA'){
        this.calcularFreteRota(this.total_peso, this.tot_valor_entregar);
      }
    },

    async calcularFreteRota(total_peso, tot_valor_entregar){
      try {
        if (this.parametros_empresa.tipo_frete_manifesto != 'R'){
          return;
        }
    
        if (!this.bairro_entrega_id){
          return;
        }

        let parametros  = {
          bairro_id: this.bairro_entrega_id,
          total_produtos_entregar: tot_valor_entregar,
          peso_produtos_entregar: total_peso,
          usuario_digitou_valor: false
        }
      
        let retorno = await ROrcamentoBuscarFretePorRota.buscarFretePorRota(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }
      
        this.frete_rota_buscar_entregas_ato = Object.assign({}, retorno.dados);
      } catch (error) {
        this.verificarErro(error, 'calcularFreteRota');
      }
    },

    definirTipoRetirarLojasRede(produto){
      if (Object.entries(produto).length === 0) {
        Biblioteca.exclamar('Necessário produto foi selecionado!');
        return;
      }

      this.produto_selecionado_editando = Object.assign({}, produto);
      this.modal_retirar_tipo_item = true;
    },

    tiposAgendamentoEntrega: function(){
      let tipos = [];
      
      if (this.parametros_empresa.tipo_agendamento_entrega == 'E'){
        tipos.push(
          {
            valor: 'E',
            descricao: 'DATA ESPECÍFICA'
          }
        );

        this.tipo_agendamento_entrega = 'E';
      } else if (this.parametros_empresa.tipo_agendamento_entrega == 'R'){
        tipos.push(
          {
            valor: 'E',
            descricao: 'DATA ESPECÍFICA'
          },
          {
            valor: 'R',
            descricao: 'ROTATIVO'
          },
        );

        this.tipo_agendamento_entrega = 'R';
      } else if (this.parametros_empresa.tipo_agendamento_entrega == 'P'){
        tipos.push(
          {
            valor: 'E',
            descricao: 'DATA ESPECÍFICA'
          },
          {
            valor: 'R',
            descricao: 'ROTATIVO'
          },
          {
            valor: 'P',
            descricao: 'ROTATIVO, A PARTIR DE UMA DATA'
          },
        );

        this.tipo_agendamento_entrega = 'R';
      }

      this.tiposAgendamentoArray = tipos;
    },
  }
}
</script>
<style scoped>
  .card-mensagem:hover { background-color: #fff !important }
  .card-mensagem:hover label{ color: #9c1d1c !important; }
  .card-mensagem:hover p,
  .card-mensagem:hover span{color: #636363 !important}

  h2{
  border-bottom: 1px solid #9c1d1c;
  }

  @media screen and (max-width: 600px){
    .recebimento-mobile {
      margin-top: 16px !important;
      text-align: center;
    }
  }

  @media screen and (max-width: 767px){
    h2{
      font-size: 24px;
      margin-bottom:15px;
    }

    h5 {
      margin-left: 0 !important;
    }
    
    #principal > .w3-container{
      padding:0 !important;
    }

    .fechar-pedido{
      width: calc(100% - 32px);
      margin: 0 16px;
    }

    #tabPrincipais div span:first-of-type{
      margin-bottom: 15px;
    }

    .div-btn-filtro {
      margin-top: 0 !important;
      margin-bottom: 16px;
    }

    .padding-info {
      padding: 0;
    }

    .table-entrega-ato .max-width .check-no-ato {
      width: 18px !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  }

  .w3-modal-content{
    width: auto !important; 
    margin: 20px !important
  }


  .w3-modal {
    padding-top: 60px !important;
    padding-bottom: 10px;
  }

  .disable {
    opacity: 0.5
  }

  .enable {
    opacity: 1
  }

  #tam_nome_prod:focus { 
    text-align: left;
  }

  #tam_nome_prod { 
    text-align: right;
  }

  .switch-input {
    display: none;
  }

  .max-width {
    height: 42px
  }

  .input-entra-ato {
    color: rgb(55, 128, 55);
    text-align: center;
    cursor: pointer;
    
    border-bottom: none;
    border-color: transparent;
    background-color: rgba(144, 238, 144, 0.21);

    width: 100% !important;
    height: 100% !important;
  }

  .input-entra-ato:focus {
    border-color: rgb(50, 156, 50);
    outline: none;
    border: 1px solid;
    -webkit-appearance: none;
  }

  .sem-agendamento {
    background-color: #ff000021; 
    color: red;     
  }

  .check-no-ato {
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .hide-data-previsao {
    display: none;
  }

  .drop-down-ato {
    padding: 5px;
    cursor: default !important;     
    margin-bottom: 5px  ;  
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;     
    width: auto !important;
  }

  .tr-items:hover {
    background: #9c1d1cb8;
    color:#fff;
    cursor: pointer;
  }

  .tr-items-ativo:hover {
    background: #9c1d1c;
    color: white;
  }

  .tr-items-ativo {
    background: #9c1d1c;
    color: white;
  }

  .switch-label-inative {
    color: #000;
  }

  .switch-label-active {
    color: #057273;
    font-weight: bold;
  }

  .switch-label {
    position: relative;
    display: inline-block;
    min-width: 112px;
    cursor: pointer;
    text-align: left;
    padding: 10px 0 10px 44px;
  }

  .drop-down-ato:focus {
    -webkit-touch-callout: none !important;
    -webkit-user-select: none !important;
    -khtml-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
    -webkit-tap-highlight-color: transparent !important;
  }

  .switch-label:before, .switch-label:after {
    content: "";
    position: absolute;
    margin: 0;
    outline: 0;
    top: 50%;
    -ms-transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .switch-label:before {
    left: 1px;
    width: 34px;
    height: 14px;
    background-color: #dfe4ea;
    border-radius: 8px;
  }

  .switch-label:after {
    left: 0;
    width: 20px;
    height: 20px;
    background-color: #057273;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
  }

  .switch-label .toggle--on {
    display: none;
  }

  .switch-label .toggle--off {
    display: inline-block;
  }

  .switch-input:checked + .switch-label:before {
    background-color: #dfe4ea;
  }

  .switch-input:checked + .switch-label:after {
    background-color: #057273;
    -ms-transform: translate(80%, -50%);
    -webkit-transform: translate(80%, -50%);
    transform: translate(80%, -50%);
  }

  .label-info {
    line-height: 35px; 
    border-bottom: 1px solid black
  }

  .line-label {
    line-height: 35px;
    text-align: right; 
    border-bottom: 1px solid black
  }

  .total-produtos-entrega.frete{ 
    color: #333
  }

  .total-produtos-entrega{
    font-weight: bold;
    color: rgb(55, 128, 55);
    font-size: 20px;
    -webkit-appearance: none;
    background: transparent;
    border:none;
  }

  .total-produtos > div{
    border-bottom:  1px solid #000;
  }

  @media screen and (min-width: 1200px){
    .total-produtos label{ 
      line-height: 40px;
    }

    .card-lote button:hover{
      background-color: #9c1d1c !important;
      color: #fff !important;
      box-shadow: 0px 2px 32px #00000090;
    }
  }

  @media screen and (max-width: 675px){
    .w3-container{ padding:0 }

    .card-lote{
      margin:10px 0 !important;
    }
  }

  .card-ato{
    background-color: #ebebeb;
    border: 2px solid #ebebeb;
    padding: 10px;
    border-radius: 20px;
  }

  .card-tipo-veiculo{
    background-color: #dedcdc;
    border: 2px solid #dedcdc;
    padding: 10px;
    border-radius: 20px;
    box-shadow: #c9c9c9 1px 1px 1px 1px;
  }

  .card-lote{
    background-color: #ebebeb;
    border: 2px solid #ebebeb;
    padding: 10px;
    border-radius: 20px;
  }

  .card-lote.active{
    background: #ebebeb;
  }

  .texto-verde{
    color: green;
  }

  .texto-azul{
    color: blue;
  }

  .fundo-veiculos-transporte {
    background-color: #9c1d1c;
    color: white;
    margin-left: 2px;
    border-radius: 5px;
    font-size: 14px;
  }

  .card-botao-mostrar-veiculos{
    margin-top:15px;
    border-radius: 10px 10px 10px 10px;
    border: 2px solid #bfbfbf; 
  }
  
</style>


// WEBPACK FOOTER //
// src/components/Orcamentos/BuscarEntregasNoAto.vue